import {
  ArrowUpOutlined,
  CloseOutlined,
  DeleteOutlined,
  FileOutlined,
  FrownOutlined,
  InboxOutlined,
  LoadingOutlined,
  MehOutlined,
  PrinterOutlined,
  SaveOutlined,
  SearchOutlined,
  SmileOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Input,
  Row,
  Select,
  Tabs,
  Table,
  Typography,
  message,
  Rate,
  notification,
  Spin,
  Popconfirm,
  BackTop,
  Tooltip,
  Upload,
  Empty,
  Image,
  Modal,
} from "antd";
import moment from "moment";
import React from "react";
import { withRouter } from "react-router";
import SignaturePad from "react-signature-canvas";
import { generateToken } from "../../../auth/auth";
import { axiosInstance } from "../../../commons/commons";
import {
  decodedToken,
  encodedToken,
  stateStore,
} from "../../../constants/constants";
import {
  building,
  legalCompany,
  division,
  priority,
  project,
  subStatus,
  unit,
  vwRentalTcList,
  complaintSource,
  complaintType,
  buildingAssets,
  buildingAssetLocation,
  buildingAssetSubLocation,
  maintenanceTeam,
  designation,
  contacts,
  employeeRate,
  materialCategory,
  complaint,
  baseUrl,
  attachment,
  documentAttachment,
  complaintStatus,
  complaintCategory,
} from "../../../constants/url";

class JobRegistration extends React.Component {
  _isMounted = false;
  state = {
    companyData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    divisionData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    projectData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    buildingData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    unitData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    subStatusData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    priorityData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    complaintSourceData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    complaintTypeData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    complaintStatusData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    complaintCategoryData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    assetNameData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    assetLocationData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    assetSubLocationData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    designationData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    materialCategoryData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    materialItemData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    tenantData: {},
    complaintData: {
      // EnteredBy:decodedToken.value.User_ID||decodedToken.value.TenantID||1,
      // Entered_Party_Type:
      //   decodedToken.value.activeKey === "employee" ? "E" : "T",
      // ComplaintDetails: [{}],
      // ComplaintDate: moment(new Date(), "YYYY-MM-DD"),
      // ExpectedStartDate: new Date().toISOString().split("T")[0],
      // ExpectedStartTime: "00:00",
      // ExpectedDurationHours: 0.0,
      // ExpectedEndDate: new Date().toISOString().split("T")[0],
      // ActualStartDate: new Date().toISOString().split("T")[0],
      // ActualStartTime: "00:00",
      // ActualDurationHours: 0.0,
      // ActualEndDate: new Date().toISOString().split("T")[0],
      ComplaintManpowers: [],
      ComplaintMaterials: [],
      ComplaintDetails: [{}], // details of the complaint
      ComplaintDate: moment(new Date(), "YYYY-MM-DD"),
      ExpectedStartDate: new Date().toISOString().split("T")[0],
      ExpectedStartTime: "00:00",
      ExpectedDurationHours: 0.0,
      ExpectedEndDate: new Date().toISOString().split("T")[0],
      ActualStartDate: new Date().toISOString().split("T")[0],
      ActualStartTime: "00:00",
      ActualDurationHours: 0.0,
      ActualEndDate: new Date().toISOString().split("T")[0],
      ComplaintManpowers: [],
      ComplaintMaterials: [],
      JobRepeatNew: "NEW",
      JobOrderType: "AMC",
      JobOrderSubType: "PPM",
      OpenClosed: "Open",
      EnteredBy: decodedToken.value.User_ID || decodedToken.value.TenantID || 1,
      Entered_Party_Type:
        decodedToken.value.activeKey === "employee" ? "E" : "T",
      Creator: {
        User_Name: decodedToken.value.User_Name || decodedToken.value.Customer,
      },
      CreatedThroughWeb: true,
      Viewed: null,
      respondedAt: null,
      ComplaintAttachments: [], // list of the ComplaintAttachments related to a particular complaint
    },
    expectedDateRange: "",
    actualDateRange: "",
    teamData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    leaderData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    employeeData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    tabData: { activeKey: "0" },
    createUpdateDisabled: false,
    deletionDisabled: false,
    deletingComplaint: false,
    dataBeingSaved: false,
    dataIsLoading: false,
    manpowerRate: { selectedValue: 0 },
    noOfHours: { selectedValue: 0 },
    manpowerAmount: { selectedValue: 0 },
    manpowerDescription: { selectedValue: "" },
    problemDescription: { selectedValue: "" },
    qty: { selectedValue: "" },
    materialAmount: { selectedValue: 0 },
    materialRate: { selectedValue: 0 },
    materialBilled: false,
    materialDescription: { selectedValue: "" },
    feedbackRate: {
      customIcons: {
        1: <FrownOutlined />,
        2: <FrownOutlined />,
        3: <MehOutlined />,
        4: <SmileOutlined />,
        5: <SmileOutlined />,
      },
      list: ["Poor", "Fair", "Average", "Good", "Excellent"],
    },
    manpowerTableData: { list: [], validateColor: "#d9d9d9" },
    reportURL: "http://www.orimi.com/pdf-test.pdf",
    printIsDisabled: false,
    printDataLoading: false,
    reportViewerIsHidden: true,
    signatureModalIsVisible: false,
    parent: "jobSearch",
    dateFormat: "YYYY-MM-DD",
    timeFormat: "HH:mm",
    attachmentList: [], // list of files that has been selected to upload
  };

  reportViewerRef = null;
  signatureRef = null;
  controller = new AbortController();

  problemTypeColumns = [
    {
      title: (
        <Typography.Title
          ellipsis={{
            rows: 1,
            tooltip: true,
          }}
          style={{ fontSize: "14px" }}
        >
          Problem Type
        </Typography.Title>
      ),
      dataIndex: "ComplaintType",
      key: "ProblemType",
      align: "center",
      // render: value=>{}
    },
    {
      title: (
        <Typography.Title
          ellipsis={{
            rows: 1,
            tooltip: true,
          }}
          style={{ fontSize: "14px" }}
        >
          Asset Name
        </Typography.Title>
      ),
      dataIndex: "Asset",
      key: "AssetName",
      align: "center",
      // render: value=>{}
    },
    {
      title: (
        <Typography.Title
          ellipsis={{
            rows: 1,
            tooltip: true,
          }}
          style={{ fontSize: "14px" }}
        >
          Description
        </Typography.Title>
      ),
      dataIndex: "Description",
      key: "Description",
      align: "center",
      // render: value=>{}
    },
    {
      title: (
        <Typography.Title
          ellipsis={{
            rows: 1,
            tooltip: true,
          }}
          style={{ fontSize: "14px" }}
        >
          Action
        </Typography.Title>
      ),
      dataIndex: "action",
      key: "action",
      align: "center",
      render: (_, item) => {
        return (
          <div>
            <DeleteOutlined
              onClick={() => {
                let state = this.state;
                state.complaintData.ComplaintDetails =
                  state.complaintData.ComplaintDetails.filter(
                    (data) => data.key !== item.key
                  );
                this.setState(state);
              }}
            />
          </div>
        );
      },
    },
  ];

  manpowerColumns = [
    {
      title: (
        <Typography.Title
          ellipsis={{
            rows: 1,
            tooltip: true,
          }}
          style={{ fontSize: "14px" }}
        >
          Employee
        </Typography.Title>
      ),
      dataIndex: ["Contact", "ContactName"],
      key: "EmployeeName",
      align: "center",
      width: 100,
      // render: value=>{}
    },
    {
      title: (
        <Typography.Title
          ellipsis={{
            rows: 1,
            tooltip: true,
          }}
          style={{ fontSize: "14px" }}
        >
          No. of Hours
        </Typography.Title>
      ),
      dataIndex: "Hours",
      key: "Hours",
      align: "center",
      width: 100,
      // render: value=>{}
    },
    {
      title: (
        <Typography.Title
          ellipsis={{
            rows: 1,
            tooltip: true,
          }}
          style={{ fontSize: "14px" }}
        >
          Rate
        </Typography.Title>
      ),
      dataIndex: "Rate",
      key: "Rate",
      align: "center",
      width: 100,
      // render: value=>{}
    },
    {
      title: (
        <Typography.Title
          ellipsis={{
            rows: 1,
            tooltip: true,
          }}
          style={{ fontSize: "14px" }}
        >
          Amount
        </Typography.Title>
      ),
      dataIndex: "Amount",
      key: "Amount",
      align: "center",
      width: 100,
      // render: value=>{}
    },
    {
      title: (
        <Typography.Title
          ellipsis={{
            rows: 1,
            tooltip: true,
          }}
          style={{ fontSize: "14px" }}
        >
          Description
        </Typography.Title>
      ),
      dataIndex: "Description",
      key: "Description",
      align: "center",
      width: 100,
      // render: value=>{}
    },
    {
      title: (
        <Typography.Title
          ellipsis={{
            rows: 1,
            tooltip: true,
          }}
          style={{ fontSize: "14px" }}
        >
          Action
        </Typography.Title>
      ),
      dataIndex: "action",
      key: "action",
      align: "center",
      width: 100,
      render: (_, item) => {
        return (
          <div>
            <DeleteOutlined
              onClick={() => {
                const temp = [];
                let state = this.state;
                this.state.complaintData.ComplaintManpowers.map((data) => {
                  if (data.key !== item.key) temp.push(data);
                  return data;
                });
                state.complaintData.ComplaintManpowers = temp;
                this.setState(state);
              }}
            />
          </div>
        );
      },
    },
  ];

  materialColumns = [
    {
      title: (
        <Typography.Title
          ellipsis={{
            rows: 1,
            tooltip: true,
          }}
          style={{ fontSize: "14px" }}
        >
          Item
        </Typography.Title>
      ),
      dataIndex: ["MaterialItem", "MaterialName"],
      key: "Item",
      align: "center",
      width: 100,
      // render: value=>{}
    },
    {
      title: (
        <Typography.Title
          ellipsis={{
            rows: 1,
            tooltip: true,
          }}
          style={{ fontSize: "14px" }}
        >
          Qty.
        </Typography.Title>
      ),
      dataIndex: "Qty",
      key: "Qty",
      align: "center",
      width: 100,
      // render: value=>{}
    },
    {
      title: (
        <Typography.Title
          ellipsis={{
            rows: 1,
            tooltip: true,
          }}
          style={{ fontSize: "14px" }}
        >
          Rate
        </Typography.Title>
      ),
      dataIndex: "Rate",
      key: "Rate",
      align: "center",
      width: 100,
      // render: value=>{}
    },
    {
      title: (
        <Typography.Title
          ellipsis={{
            rows: 1,
            tooltip: true,
          }}
          style={{ fontSize: "14px" }}
        >
          Amount
        </Typography.Title>
      ),
      dataIndex: "Amount",
      key: "Amount",
      align: "center",
      width: 100,
      // render: value=>{}
    },
    {
      title: (
        <Typography.Title
          ellipsis={{
            rows: 1,
            tooltip: true,
          }}
          style={{ fontSize: "14px" }}
        >
          Description
        </Typography.Title>
      ),
      dataIndex: "Description",
      key: "Description",
      align: "center",
      width: 120,
      // render: value=>{}
    },
    {
      title: (
        <Typography.Title
          ellipsis={{
            rows: 1,
            tooltip: true,
          }}
          style={{ fontSize: "14px" }}
        >
          Action
        </Typography.Title>
      ),
      dataIndex: "action",
      key: "action",
      align: "center",
      width: 100,
      render: (_, item) => {
        return (
          <div>
            <DeleteOutlined
              onClick={() => {
                const temp = [];
                let state = this.state;
                this.state.complaintData.ComplaintMaterials.map((data) => {
                  if (data.key !== item.key) temp.push(data);
                  return data;
                });
                state.complaintData.ComplaintMaterials = temp;
                this.setState(state);
              }}
            />
          </div>
        );
      },
    },
  ];

  /**
   * make sure the state declarations are the same
   * for getInitialState and this component's state.
   *
   * state in this method is declared in order to
   * make sure default values along with the current
   * preserved state can be retrieved to set the
   * new state.
   */
  getInitialState = async () => {
    let state = {
      companyData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      divisionData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      projectData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      buildingData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      unitData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      tenantData: {},
      subStatusData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      priorityData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      complaintSourceData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      complaintTypeData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      complaintStatusData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      complaintCategoryData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      assetNameData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      assetLocationData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      assetSubLocationData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      designationData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      materialCategoryData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      materialItemData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      /**
       * a complaint data for creating or updating
       * will reside in this property.
       */
      complaintData: {
        ComplaintDetails: [{}], // details of the complaint
        ComplaintDate: moment(
          new Date(),
          this.state.dateFormat + " " + this.state.timeFormat
        ),
        ExpectedStartDate: new Date().toISOString().split("T")[0],
        ExpectedStartTime: "00:00",
        ExpectedDurationHours: 0.0,
        ExpectedEndDate: new Date().toISOString().split("T")[0],
        ActualStartDate: new Date().toISOString().split("T")[0],
        ActualStartTime: "00:00",
        ActualDurationHours: 0.0,
        ActualEndDate: new Date().toISOString().split("T")[0],
        ComplaintManpowers: [],
        ComplaintMaterials: [],
        JobRepeatNew: "NEW",
        JobOrderType: "AMC",
        JobOrderSubType: "PPM",
        OpenClosed: "Open",
        ComplaintStatusID: 1,
        EnteredBy:
          decodedToken.value.User_ID || decodedToken.value.TenantID || 1,
        Entered_Party_Type:
          decodedToken.value.activeKey === "employee" ? "E" : "T",
        Creator: {
          User_Name:
            decodedToken.value.User_Name || decodedToken.value.Customer,
        },
        CreatedThroughWeb: true,
        Viewed: null,
        respondedAt: null,
        ComplaintAttachments: [], // list of the ComplaintAttachments related to a particular complaint
      },
      expectedDateRange: "",
      actualDateRange: "",
      teamData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      leaderData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      employeeData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      manpowerRate: { selectedValue: 0 },
      noOfHours: { selectedValue: "" },
      manpowerAmount: { selectedValue: 0 },
      manpowerDescription: { selectedValue: "" },
      problemDescription: { selectedValue: "" },
      qty: { selectedValue: "" },
      materialAmount: { selectedValue: 0 },
      materialBilled: false,
      materialRate: { selectedValue: 0 },
      materialDescription: { selectedValue: "" },
      feedbackRate: {
        customIcons: {
          1: <FrownOutlined />,
          2: <FrownOutlined />,
          3: <MehOutlined />,
          4: <SmileOutlined />,
          5: <SmileOutlined />,
        },
        list: ["Poor", "Fair", "Average", "Good", "Excellent"],
      },
      tabData: { activeKey: "1" },
      dataBeingSaved: false,
      createUpdateDisabled: false,
      deletionDisabled: false,
      deletingComplaint: false,
      dataIsLoading: false,
      reportURL: "http://www.orimi.com/pdf-test.pdf",
      printIsDisabled: false,
      printDataLoading: false,
      reportViewerIsHidden: true,
      signatureModalIsVisible: false,
      parent: "jobSearch",
      dateFormat: "YYYY-MM-DD",
      timeFormat: "HH:mm",
      attachmentList: [], // list of files that has been selected to upload
    };
    await axiosInstance
      .get(legalCompany)
      .then((res) => {
        if (res.data.success) state.companyData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(subStatus)
      .then((res) => {
        if (res.data.success) state.subStatusData.list = res.data.message;
        state.subStatusData.list.map((priority, index) => {
          if (priority.UserName.toLowerCase().includes("under process")) {
            state.subStatusData.selectedIndex = index;
            state.subStatusData.selectedValue = priority.UserName;
            // state.complaintData.Priority = priority.UserName;
          }
          return priority;
        });
      })
      .catch(() => {});
    await axiosInstance
      .get(priority)
      .then((res) => {
        if (res.data.success) state.priorityData.list = res.data.message;
        // state.priorityData.list.map((priority, index) => {
        //   if (priority.UserName.toLowerCase().includes("medium")) {
        //     state.priorityData.selectedIndex = index;
        //     state.priorityData.selectedValue = priority.UserName;
        //     state.complaintData.Priority = priority.UserName;
        //   }
        //   return priority;
        // });
      })
      .catch(() => {});
    // await axiosInstance
    //   .get(complaintSource)
    //   .then((res) => {
    //     if (res.data.success) state.complaintSourceData.list = res.data.message;
    //     state.complaintSourceData.list.map((source, index) => {
    //       if (source.UserName.toLowerCase().includes("watchman")) {
    //         state.complaintSourceData.selectedIndex = index;
    //         state.complaintSourceData.selectedValue = source.UserName;
    //         state.complaintData.ProblemOriginID = source.SourceID;
    //         state.complaintData.ProblemOrigin = source.UserName;
    //       }
    //       return source;
    //     });
    //   })
    //   .catch(() => {});
    await axiosInstance
      .get(complaintType)
      .then((res) => {
        if (res.data.success) state.complaintTypeData.list = res.data.message;
        state.complaintTypeData.list.map((type, index) => {
          if (
            type.UserName.toLowerCase().indexOf("general".toLowerCase()) !== -1
          ) {
            state.complaintTypeData.selectedIndex = index;
            state.complaintTypeData.selectedValue = type.UserName;
            state.complaintData.ComplaintDetails[0].ComplaintTypeID =
              type.ComplaintTypeID;
            state.complaintData.ComplaintTypeID = type.ComplaintTypeID;
          }
          return type;
        });
      })
      .catch(() => {});
    // await axiosInstance
    //   .get(complaintCategory)
    //   .then((res) => {
    //     if (res.data.success)
    //       state.complaintCategoryData.list = res.data.message;
    //     state.complaintCategoryData.list.map((category, index) => {
    //       if (
    //         category.UserName.toLowerCase().indexOf("general".toLowerCase()) !==
    //         -1
    //       ) {
    //         state.complaintTypeData.selectedIndex = index;
    //         state.complaintTypeData.selectedValue = category.UserName;
    //         state.complaintData.ComplaintDetails[0].ComplaintCategoryID =
    //           category.ComplaintCategoryID;
    //         state.complaintData.ComplaintCategoryID =
    //           category.ComplaintCategoryID;
    //       }
    //       return category;
    //     });
    //   })
    //   .catch(() => {});
    // await axiosInstance
    //   .get(complaintStatus)
    //   .then((res) => {
    //     if (res.data.success) state.complaintStatusData.list = res.data.message;
    //     state.complaintStatusData.list.map((status, index) => {
    //       if (
    //         status.UserName.toLowerCase().indexOf("general".toLowerCase()) !==
    //         -1
    //       ) {
    //         state.complaintStatusData.selectedIndex = index;
    //         state.complaintStatusData.selectedValue = status.UserName;
    //         state.complaintData.ComplaintStatusID = status.ComplaintStatusID;
    //       }
    //       return status;
    //     });
    //   })
    //   .catch(() => {});
    // await axiosInstance
    //   .get(buildingAssetLocation)
    //   .then((res) => {
    //     if (res.data.success) state.assetLocationData.list = res.data.message;
    //   })
    //   .catch(() => {});
    // await axiosInstance
    //   .get(buildingAssetSubLocation)
    //   .then((res) => {
    //     if (res.data.success)
    //       state.assetSubLocationData.list = res.data.message;
    //   })
    //   .catch(() => {});
    // await axiosInstance
    //   .get(maintenanceTeam)
    //   .then((res) => {
    //     if (res.data.success)
    //       state.teamData.list = res.data.message.filter(
    //         (team) =>
    //           team.MaintenanceTeamEmployees &&
    //           team.MaintenanceTeamEmployees.filter(
    //             (employee) => employee.Contact
    //           ).length
    //       );
    //   })
    //   .catch(() => {});
    await axiosInstance
      .get(designation)
      .then((res) => {
        if (res.data.success) state.designationData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(materialCategory)
      .then((res) => {
        if (res.data.success)
          state.materialCategoryData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(contacts + "?categoryName=Employee")
      .then((res) => {
        if (res.data.success)
          state.leaderData.list = res.data.message.rows || [];
      })
      .catch(() => {});
    return state;
  };

  onChange = (value) => {
    if (!value) return;
    let state = this.state;
    let theIndex = value.split("+-")[1];
    let theValue = value.split("+-")[2];
    switch (value.split("+-")[0]) {
      case "adminCompany":
        state.complaintData.TCID = null;
        // set company data and reset other
        this.setState(
          {
            companyData: {
              list: state.companyData.list,
              selectedIndex: theIndex,
              selectedValue: theValue,
            },
            divisionData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
              icon: theValue ? (
                <LoadingOutlined style={{ color: "#1890ff" }} />
              ) : null,
            },
            projectData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
            },
            buildingData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
            },
            unitData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
            },
            assetNameData: {
              list: state.assetNameData.list,
              selectedIndex: null,
              selectedValue: null,
            },
            tenantData: {},
          },
          () => {
            state = this.state;
            state.complaintData.LegalCompany_ID =
              state.companyData.list[theIndex].LegalCompanyID;
            this.setState(state);
            if (theValue)
              axiosInstance
                .get(
                  division +
                    "?LegalCompanyID=" +
                    state.companyData.list[theIndex].LegalCompanyID
                )
                .then((res) => {
                  if (res.data.success)
                    this.setState({
                      divisionData: {
                        list: res.data.message,
                        selectedIndex: null,
                        selectedValue: null,
                      },
                    });
                })
                .catch(() => {
                  this.setState({
                    divisionData: {
                      list: [],
                      selectedIndex: null,
                      selectedValue: null,
                    },
                  });
                });
          }
        );
        break;
      case "division":
        state.complaintData.TCID = null;
        this.setState(
          {
            divisionData: {
              list: state.divisionData.list,
              selectedIndex: theIndex,
              selectedValue: theValue,
            },
            projectData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
              icon: theValue ? (
                <LoadingOutlined style={{ color: "#1890ff" }} />
              ) : null,
            },
            buildingData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
            },
            unitData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
            },
            assetNameData: {
              list: state.assetNameData.list,
              selectedIndex: null,
              selectedValue: null,
            },
            tenantData: {},
          },
          () => {
            state = this.state;
            state.complaintData.Division_ID =
              state.divisionData.list[theIndex].DivisionID;
            this.setState(state);
            if (theValue)
              axiosInstance
                .get(
                  project +
                    "?DivisionID=" +
                    state.divisionData.list[theIndex].DivisionID
                )
                .then((res) => {
                  if (res.data.success)
                    this.setState({
                      projectData: {
                        list: res.data.message,
                        selectedIndex: null,
                        selectedValue: null,
                      },
                    });
                })
                .catch(() => {
                  this.setState({
                    projectData: {
                      list: [],
                      selectedIndex: null,
                      selectedValue: null,
                    },
                  });
                });
          }
        );
        break;
      case "project":
        state.complaintData.TCID = null;
        this.setState(
          {
            projectData: {
              list: state.projectData.list,
              selectedIndex: theIndex,
              selectedValue: theValue,
            },
            buildingData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
              icon: theValue ? (
                <LoadingOutlined style={{ color: "#1890ff" }} />
              ) : null,
            },
            unitData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
            },
            assetNameData: {
              list: state.assetNameData.list,
              selectedIndex: null,
              selectedValue: null,
            },
            tenantData: {},
          },
          () => {
            state = this.state;
            state.complaintData.ProjectID =
              state.projectData.list[theIndex].ProjectID;
            this.setState(state);
            if (theValue)
              axiosInstance
                .get(
                  building +
                    "?ProjectID=" +
                    state.projectData.list[theIndex].ProjectID +
                    (decodedToken.value.ContactID &&
                    decodedToken.value.Role_ID !== 1
                      ? "&incharge_id=" + decodedToken.value.ContactID
                      : "")
                )
                .then((res) => {
                  if (res.data.success) {
                    this.setState({
                      buildingData: {
                        list: res.data.message,
                        selectedIndex: null,
                        selectedValue: null,
                      },
                    });
                  }
                })
                .catch(() => {
                  this.setState({
                    buildingData: {
                      list: [],
                      selectedIndex: null,
                      selectedValue: null,
                    },
                  });
                });
          }
        );
        break;
      case "building":
        this.setState(
          {
            buildingData: {
              list: state.buildingData.list,
              selectedIndex: theIndex,
              selectedValue: theValue,
            },
            unitData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
              icon: theValue ? (
                <LoadingOutlined style={{ color: "#1890ff" }} />
              ) : null,
            },
            assetNameData: {
              list: state.assetNameData.list,
              selectedIndex: null,
              selectedValue: null,
              icon: theValue ? (
                <LoadingOutlined style={{ color: "#1890ff" }} />
              ) : null,
            },
            tenantData: {},
          },
          () => {
            state = this.state;
            state.complaintData.BuildingID =
              state.buildingData.list[theIndex].BuildingID;
            state.complaintData.TCID = null;
            state.leaderData.list.map((ld, index) => {
              if (
                ld.ContactID ===
                ((state.buildingData.list[theIndex] || {}).Contact || {})
                  .ContactID
              ) {
                state.leaderData.selectedIndex = index;
                state.leaderData.selectedValue = ld.ContactName;
                state.complaintData.SupervisorID = ld.ContactID;
              }
              return ld;
            });
            this.setState(state);
            if (theValue) {
              axiosInstance
                .get(
                  unit +
                    "?BuildingID=" +
                    state.buildingData.list[theIndex].BuildingID +
                    "&RentalUnitsubStatusID=2"
                )
                .then((res) => {
                  if (res.data.success)
                    this.setState({
                      unitData: {
                        list: res.data.message,
                        selectedIndex: null,
                        selectedValue: null,
                      },
                    });
                })
                .catch(() => {
                  this.setState({
                    unitData: {
                      list: [],
                      selectedIndex: null,
                      selectedValue: null,
                    },
                  });
                });
              axiosInstance
                .get(
                  buildingAssets +
                    "?BuildingID=" +
                    state.buildingData.list[theIndex].BuildingID
                )
                .then((res) => {
                  if (res.data.success)
                    this.setState({
                      assetNameData: {
                        list: res.data.message,
                        selectedIndex: null,
                        selectedValue: null,
                      },
                    });
                })
                .catch(() => {
                  this.setState({
                    assetNameData: {
                      list: [],
                      selectedIndex: null,
                      selectedValue: null,
                    },
                  });
                });
            }
          }
        );
        break;
      case "unit":
        this.setState(
          {
            unitData: {
              list: state.unitData.list,
              selectedIndex: theIndex,
              selectedValue: theValue,
            },
            tenantData: {
              icon: theValue ? (
                <LoadingOutlined style={{ color: "#1890ff" }} />
              ) : null,
            },
          },
          () => {
            state = this.state;
            state.complaintData.UnitID =
              state.unitData.list[state.unitData.selectedIndex].UnitID;
            this.setState(state);
            if (theValue)
              axiosInstance
                .get(
                  /**
                   * fetching only Active TC(TCStatus=Active)
                   * for this tenant to assign new complaint
                   * to that active TCID.
                   * if TCStatus=Active is not provided, then
                   * the new complaint could register to old TCID.
                   * we should avoid that because whenever tenant
                   * logs in(can only login with active TC(s)), then
                   * they wouldnot find the registered complaint since
                   * it was registered to old TC of which they cannot
                   * login through.
                   */
                  vwRentalTcList +
                    "?TCStatus=Active&LegalCompany_ID=" +
                    state.companyData.list[state.companyData.selectedIndex]
                      .LegalCompanyID +
                    "&BuildingID=" +
                    state.buildingData.list[state.buildingData.selectedIndex]
                      .BuildingID +
                    "&UnitID=" +
                    state.unitData.list[theIndex].UnitID
                )
                .then((res) => {
                  state = this.state;
                  if (res.data.success) {
                    state.tenantData = {
                      ...(res.data.message[0] || {}),
                    };
                    state.complaintData.TCID = state.tenantData.TCID;
                  }
                  this.setState(state);
                })
                .catch(() => {
                  this.setState({
                    tenantData: {},
                  });
                });
          }
        );
        break;
      case "designation":
        this.setState(
          {
            designationData: {
              list: this.state.designationData.list,
              selectedIndex: theIndex,
              selectedValue: theValue,
            },
            employeeData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
              icon: theValue ? (
                <LoadingOutlined style={{ color: "#1890ff" }} />
              ) : null,
            },
          },
          () =>
            axiosInstance
              .get(
                contacts +
                  "?ContactCategoryID=1&DesignationID=" +
                  this.state.designationData.list[
                    this.state.designationData.selectedIndex
                  ].DesignationID
              )
              .then((res) => {
                this.setState({
                  employeeData: {
                    list: res.data.message.rows,
                    selectedIndex: null,
                    selectedValue: null,
                    icon: null,
                  },
                });
              })
              .catch(() => {})
        );
        break;
      case "employee":
        this.setState(
          {
            employeeData: {
              list: this.state.employeeData.list,
              selectedIndex: theIndex,
              selectedValue: theValue,
            },
            manpowerRate: {
              icon: theValue ? (
                <LoadingOutlined style={{ color: "#1890ff" }} />
              ) : null,
            },
          },
          () =>
            axiosInstance
              .get(
                employeeRate +
                  "?ContactID=" +
                  this.state.employeeData.list[
                    this.state.employeeData.selectedIndex
                  ].ContactID
              )
              .then((res) => {
                this.setState({
                  manpowerRate: {
                    selectedValue:
                      res.data.message[0] && res.data.message[0].RatePerHour
                        ? res.data.message[0].RatePerHour
                        : 0,
                    icon: null,
                  },
                  manpowerAmount: {
                    selectedValue:
                      (res.data.message[0] && res.data.message[0].RatePerHour
                        ? res.data.message[0].RatePerHour
                        : 0) * Number(this.state.noOfHours.selectedValue) || 0,
                  },
                });
              })
              .catch(() => {})
        );
        break;
      case "subStatus":
        state.subStatusData.selectedIndex = theIndex;
        state.subStatusData.selectedValue = theValue;
        state.complaintData.ComplaintStatusID =
          state.subStatusData.list[theIndex].ComplaintStatusID;
        this.setState(state);
        break;
      case "priority":
        state.priorityData.selectedIndex = theIndex;
        state.priorityData.selectedValue = theValue;
        state.complaintData.Priority = theValue;
        this.setState(state);
        break;
      case "complaintSource":
        state.complaintSourceData.selectedIndex = theIndex;
        state.complaintSourceData.selectedValue = theValue;
        state.complaintData.ProblemOrigin = theValue;
        state.complaintData.ProblemOrigin =
          state.complaintSourceData.list[theIndex].UserName;
        state.complaintData.ProblemOriginID =
          state.complaintSourceData.list[theIndex].SourceID;
        this.setState(state);
        break;
      case "complaintType":
        state.complaintTypeData.selectedIndex = theIndex;
        state.complaintTypeData.selectedValue = theValue;
        /**
         * below two assignations are for FM APP which donot have multiple
         * problem type/pane
         */
        state.complaintData.ComplaintDetails[0].ComplaintTypeID =
          state.complaintTypeData.list[theIndex].ComplaintTypeID;
        state.complaintData.ComplaintTypeID =
          state.complaintTypeData.list[theIndex].ComplaintTypeID;
        state.priorityData.selectedIndex = null;
        state.priorityData.selectedValue = null;
        state.complaintData.Priority =
          state.complaintTypeData.list[theIndex].Priority;
        state.priorityData.list.map((pd, index) => {
          if (
            pd.UserName.toLowerCase() ===
            (
              (state.complaintTypeData.list[theIndex] || {}).Priority || "Low"
            ).toLowerCase()
          ) {
            state.priorityData.selectedIndex = index;
            state.priorityData.selectedValue = pd.UserName;
            state.complaintData.Priority = pd.UserName;
          }
          return pd;
        });
        this.setState(state);
        break;
      case "complaintCategory":
        state.complaintCategoryData.selectedIndex = theIndex;
        state.complaintCategoryData.selectedValue = theValue;
        state.complaintData.ComplaintTypeID =
          state.complaintCategoryData.list[theIndex].ComplaintCategoryID;
        this.setState(state);
        break;
      case "complaintStatus":
        state.complaintStatusData.selectedIndex = theIndex;
        state.complaintStatusData.selectedValue = theValue;
        state.complaintData.ComplaintStatusID =
          state.complaintStatusData.list[theIndex].ComplaintStatusID;
        this.setState(state);
        break;
      case "assetName":
        state.assetNameData.selectedIndex = theIndex;
        state.assetNameData.selectedValue = theValue;
        state.complaintData.ComplaintDetails[0].AssetID =
          state.assetNameData.list[theIndex].FAID;
        state.complaintData.AssetID = state.assetNameData.list[theIndex].FAID;
        this.setState(state);
        break;
      case "assetLocation":
        state.assetLocationData.selectedIndex = theIndex;
        state.assetLocationData.selectedValue = theValue;
        state.complaintData.AssetLocationID =
          state.assetLocationData.list[theIndex].LocationID;
        this.setState(state);
        break;
      case "assetSubLocation":
        state.assetSubLocationData.selectedIndex = theIndex;
        state.assetSubLocationData.selectedValue = theValue;
        state.complaintData.AssetSubLocationID =
          state.assetSubLocationData.list[theIndex].SubLocationID;
        this.setState(state);
        break;
      case "team":
        state.teamData.selectedIndex = theIndex;
        state.teamData.selectedValue = theValue;
        state.complaintData.TeamID = state.teamData.list[theIndex].TeamID;
        state.leaderData = {
          list: [],
          selectedValue: null,
          selectedIndex: null,
        };
        state.teamData.list[theIndex].MaintenanceTeamEmployees.map(
          (employee) => {
            if (employee.Contact) state.leaderData.list.push(employee.Contact);
            return employee;
          }
        );
        this.setState(state);
        break;
      case "leader":
        state.leaderData.selectedIndex = theIndex;
        state.leaderData.selectedValue = theValue;
        state.complaintData.SupervisorID =
          state.leaderData.list[theIndex].ContactID;
        this.setState(state);
        break;
      case "matCat":
        state.materialCategoryData.selectedIndex = theIndex;
        state.materialCategoryData.selectedValue = theValue;
        state.materialItemData = {
          list: [...state.materialCategoryData.list[theIndex].materials],
          selectedValue: null,
          selectedIndex: null,
        };
        this.setState(state);
        break;
      case "matItem":
        state.materialItemData.selectedIndex = theIndex;
        state.materialItemData.selectedValue = theValue;
        state.materialRate.selectedValue =
          state.materialItemData.list[theIndex].Rate || 0;
        state.materialAmount.selectedValue =
          (Number(state.materialItemData.list[theIndex].Rate) || 0) *
          (Number(state.qty.selectedValue) || 0);
        this.setState(state);
        break;
      default:
        break;
    }
  };

  initEditables = async (ComplaintID) => {
    /**
     * setting dataIsLoading true to make spinner
     * spin for indicating the data being loaded.
     *
     * setting dataBeingSaved and createupdateDisabled
     * false to stop Create/Update button disabled and
     * spin because this method is called after create
     * and updating a complaint.
     */
    this.setState({
      dataIsLoading: true,
      dataBeingSaved: false,
      createUpdateDisabled: false,
    });
    let state = this.state;
    let data;
    let tmpRes = await axiosInstance
      .get(complaint + "?ComplaintID=" + ComplaintID)
      .catch(() => {});
    if (
      tmpRes.data.success &&
      tmpRes.data.message.rows &&
      tmpRes.data.message.rows[0]
    )
      await axiosInstance // update complaint as viewed
        .put(complaint + "/updateMinors", {
          Viewed: true,
          respondedAt: tmpRes.data.message.rows[0].respondedAt,
          ComplaintID: ComplaintID,
        })
        .catch(() => {});
    let res = await axiosInstance
      .get(complaint + "?ComplaintID=" + ComplaintID)
      .catch(() => {
        this.setState({ dataIsLoading: false });
      });
    if (res.data.success && res.data.message.rows && res.data.message.rows[0])
      data = res.data.message.rows[0];
    else return this.setState({ dataIsLoading: false });
    data.ComplaintDate = moment(
      new Date(data.ComplaintDate),
      this.state.dateFormat + " " + this.state.timeFormat
    );
    // property info
    state.companyData.list.map((company, index) => {
      if (company.LegalCompanyID === data.LegalCompany_ID) {
        state.companyData.selectedIndex = index;
        state.companyData.selectedValue = company.CompanyName;
      }
      return company;
    });
    /**
     * return false from promise(then) to indicate that
     * the previous data that a current data is depended
     * on is not existent.
     */
    if (state.companyData.selectedValue)
      await axiosInstance
        .get(
          division +
            "?LegalCompanyID=" +
            state.companyData.list[state.companyData.selectedIndex]
              .LegalCompanyID
        )
        .then((res) => {
          if (res.data.success) {
            state.divisionData = {
              list: res.data.message,
              selectedIndex: null,
              selectedValue: null,
            };
            state.divisionData.list.map((division, index) => {
              if (division.DivisionID === data.Division_ID) {
                state.divisionData.selectedIndex = index;
                state.divisionData.selectedValue = division.UserName;
              }
              return division;
            });
            return state.divisionData.selectedValue;
          } else return false;
        })
        .then(async (populated) => {
          if (populated) {
            return await axiosInstance
              .get(
                project +
                  "?DivisionID=" +
                  state.divisionData.list[state.divisionData.selectedIndex]
                    .DivisionID
              )
              .then((res) => {
                if (res.data.success) {
                  state.projectData = {
                    list: res.data.message,
                    selectedIndex: null,
                    selectedValue: null,
                  };
                  state.projectData.list.map((project, index) => {
                    if (project.ProjectID === data.ProjectID) {
                      state.projectData.selectedIndex = index;
                      state.projectData.selectedValue = project.ProjectName;
                    }
                    return project;
                  });
                  return state.projectData.selectedValue;
                } else return false;
              })
              .catch(() => false);
          } else return populated;
        })
        .then(async (populated) => {
          if (populated) {
            return await axiosInstance
              .get(
                building +
                  "?ProjectID=" +
                  state.projectData.list[state.projectData.selectedIndex]
                    .ProjectID
              )
              .then((res) => {
                if (res.data.success) {
                  state.buildingData = {
                    list: res.data.message,
                    selectedIndex: null,
                    selectedValue: null,
                  };
                  state.buildingData.list.map((building, index) => {
                    if (building.BuildingID === data.BuildingID) {
                      state.buildingData.selectedIndex = index;
                      state.buildingData.selectedValue = building.BuildingName;
                    }
                    return building;
                  });
                  return state.buildingData.selectedValue;
                } else return false;
              })
              .catch(() => false);
          } else return populated;
        })
        .then(async (populated) => {
          if (populated) {
            return await axiosInstance
              .get(
                buildingAssets +
                  "?BuildingID=" +
                  state.buildingData.list[state.buildingData.selectedIndex]
                    .BuildingID
              )
              .then((res) => {
                if (res.data.success) {
                  state.assetNameData = {
                    list: res.data.message,
                    selectedIndex: null,
                    selectedValue: null,
                  };
                  state.assetNameData.list.map((asset, index) => {
                    if (
                      // asset exist in complaint details
                      data.ComplaintDetails &&
                      data.ComplaintDetails.length &&
                      data.ComplaintDetails[0].AssetID
                    ) {
                      if (asset.FAID === data.ComplaintDetails[0].AssetID) {
                        state.assetNameData.selectedIndex = index;
                        state.assetNameData.selectedValue = asset.FAName;
                      }
                    } else if (data.AssetID) {
                      // asset exist in complaint
                      if (asset.FAID === data.AssetID) {
                        state.assetNameData.selectedIndex = index;
                        state.assetNameData.selectedValue = asset.FAName;
                      }
                    }
                    return asset;
                  });
                }
                /**
                 * return true even if asset cannot
                 * be populated all others would not
                 * get populated if asset couldnot
                 * be populated.
                 */
                return true;
              })
              .catch(() => true);
          } else return populated;
        })
        .then(async (populated) => {
          if (populated) {
            return await axiosInstance
              .get(
                unit +
                  "?BuildingID=" +
                  state.buildingData.list[state.buildingData.selectedIndex]
                    .BuildingID
              )
              .then((res) => {
                if (res.data.success) {
                  state.unitData = {
                    list: res.data.message,
                    selectedIndex: null,
                    selectedValue: null,
                  };
                  state.unitData.list.map((unit, index) => {
                    if (unit.UnitID === data.UnitID) {
                      state.unitData.selectedIndex = index;
                      state.unitData.selectedValue = unit.UnitNo;
                    }
                    return unit;
                  });
                  return state.unitData.selectedValue;
                } else return false;
              })
              .catch(() => false);
          } else return populated;
        })
        .then(async (populated) => {
          if (populated) {
            return await axiosInstance
              .get(
                /**
                 * fetch TC detail without any filter
                 * of TCStatus. i.e. TCStatus=Active.
                 * because one can edit the complaint
                 * for any kind of TCStatus whether its
                 * active or not.
                 */
                vwRentalTcList +
                  "?LegalCompany_ID=" +
                  state.companyData.list[state.companyData.selectedIndex]
                    .LegalCompanyID +
                  "&BuildingID=" +
                  state.buildingData.list[state.buildingData.selectedIndex]
                    .BuildingID +
                  "&UnitID=" +
                  state.unitData.list[state.unitData.selectedIndex].UnitID
              )
              .then((res) => {
                if (res.data.success) {
                  state.tenantData = res.data.message[0] || {};
                  return true;
                } else return false;
              })
              .catch(() => false);
          } else return populated;
        })
        .catch(() => {});
    //job reference
    state.subStatusData.list.map((status, index) => {
      if (status.ComplaintStatusID === data.ComplaintStatusID) {
        state.subStatusData.selectedIndex = index;
        state.subStatusData.selectedValue = status.UserName;
      }
      return status;
    });
    state.priorityData.list.map((priority, index) => {
      if (
        priority.UserName.toLowerCase() === (data.Priority || "").toLowerCase()
      ) {
        state.priorityData.selectedIndex = index;
        state.priorityData.selectedValue = priority.UserName;
      }
      return priority;
    });
    //complaint details
    state.complaintSourceData.list.map((source, index) => {
      if (source.SourceID === data.ProblemOriginID) {
        state.complaintSourceData.selectedIndex = index;
        state.complaintSourceData.selectedValue = source.UserName;
      }
      return source;
    });
    state.complaintCategoryData.list.map((category, index) => {
      if (category.ComplaintCategoryID === data.ComplaintTypeID) {
        state.complaintCategoryData.selectedIndex = index;
        state.complaintCategoryData.selectedValue = category.UserName;
      }
      return category;
    });
    state.complaintTypeData.list.map((type, index) => {
      if (
        data.ComplaintDetails &&
        data.ComplaintDetails.length &&
        type.ComplaintTypeID === data.ComplaintDetails[0].ComplaintTypeID
      ) {
        state.complaintTypeData.selectedIndex = index;
        state.complaintTypeData.selectedValue = type.UserName;
      }
      return type;
    });
    state.complaintStatusData.list.map((status, index) => {
      if (status.ComplaintStatusID === data.ComplaintStatusID) {
        state.complaintStatusData.selectedIndex = index;
        state.complaintStatusData.selectedValue = status.UserName;
      }
      return status;
    });
    state.assetLocationData.list.map((location, index) => {
      if (location.LocationID === data.AssetLocationID) {
        state.assetLocationData.selectedIndex = index;
        state.assetLocationData.selectedValue = location.LocationName;
      }
      return location;
    });
    state.assetSubLocationData.list.map((location, index) => {
      if (location.SubLocationID === data.AssetSubLocationID) {
        state.assetSubLocationData.selectedIndex = index;
        state.assetSubLocationData.selectedValue = location.SubLocationName;
      }
      return location;
    });
    if (!data.ComplaintDetails || !data.ComplaintDetails.length)
      data.ComplaintDetails = [{}];
    //job assignment
    state.teamData.list.map((team, index) => {
      if (team.TeamID === data.TeamID) {
        state.teamData.selectedIndex = index;
        state.teamData.selectedValue = team.TeamName;
      }
      return team;
    });
    state.leaderData.selectedIndex = null;
    state.leaderData.selectedValue = null;
    if (
      state.teamData.selectedIndex != null &&
      state.teamData.list[state.teamData.selectedIndex].MaintenanceTeamEmployees
    )
      state.teamData.list[
        state.teamData.selectedIndex
      ].MaintenanceTeamEmployees.map((employee) => {
        state.leaderData.list.push(employee.Contact);
        return employee;
      });
    state.leaderData.list.map((leader, index) => {
      if (leader.ContactID === data.SupervisorID) {
        state.leaderData.selectedIndex = index;
        state.leaderData.selectedValue = leader.ContactName;
      }
      return leader;
    });
    if (data.ExpectedStartDate)
      state.expectedDateRange = [
        moment(
          data.ExpectedStartDate + " " + (data.ExpectedStartTime || ""),
          this.state.dateFormat + " " + this.state.timeFormat
        ),
        moment(
          data.ExpectedStartDate + " " + (data.ExpectedStartTime || ""),
          this.state.dateFormat + " " + this.state.timeFormat
        ).add(Number(data.ExpectedDurationHours) || 0, "hours"),
      ];
    if (data.ActualStartDate)
      state.actualDateRange = [
        moment(
          data.ActualStartDate + " " + (data.ActualStartTime || ""),
          this.state.dateFormat + " " + this.state.timeFormat
        ),
        moment(
          data.ActualStartDate + " " + (data.ActualStartTime || ""),
          this.state.dateFormat + " " + this.state.timeFormat
        ).add(Number(data.ActualDurationHours) || 0, "hours"),
      ];
    // problemType
    data.ComplaintDetails = data.ComplaintDetails.map((detail, index) => {
      detail.key = index;
      detail.ComplaintType = (detail.ComplaintType || {}).UserName;
      detail.Asset = (detail.BuildingAsset || {}).FAName;
      return detail;
    });
    // feedback
    data.FeedbackPoints =
      data.FeedbackPoints ||
      this.state.feedbackRate.list.indexOf(data.TenantFeedback) + 1;
    state.complaintData = data;
    state.dataIsLoading = false;
    if (data.OpenClosed === "Closed") data.closed = true;
    this.setState(state);
  };

  validateWritable = () => {
    let error = "";
    /**
     * put the validate condition prioritized in
     * descending order because error message is
     * stored from last.
     */
    // if (this.state.complaintData.Despatched)
    //   if (
    //     !this.state.teamData.selectedValue ||
    //     !this.state.leaderData.selectedValue
    //   )
    //     error = "Please choose a team and leader!";
    if (
      !this.state.complaintData.ComplaintID &&
      !this.state.complaintData.Remarks
    )
      error = "Please provide description!";
    if (!this.state.complaintData.ComplaintDate)
      error = "Please select complaint date!";
    if (!this.state.companyData.selectedValue)
      error = "Please select a company!";
    if (!this.state.divisionData.selectedValue)
      error = "Please select a division!";
    if (!this.state.projectData.selectedValue)
      error = "Please select a project!";
    if (!this.state.buildingData.selectedValue)
      error = "Please select a building!";
    // if (!this.state.unitData.selectedValue) error = "Please select a unit!";
    // if (!this.state.complaintData.TCID)
    //   error = "No active contract found for the selected unit!";
    if (error) {
      message.error(error);
      return false;
    } else return true;
  };

  uploadAttachments = async (ComplaintID) => {
    if (this.state.attachmentList.length || !ComplaintID) {
      let formData = new FormData();
      this.state.attachmentList.map((attachment) =>
        formData.append("file", attachment)
      );
      return await axiosInstance // upload ComplaintAttachments
        .post(attachment + "/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(async (uploadResponse) => {
          if (uploadResponse && uploadResponse.data.success) {
            // notification.success({
            //   message: "Success",
            //   description: "Uploaded!",
            // });
            if (
              uploadResponse.data.message.location &&
              uploadResponse.data.message.location.length
            ) {
              let Doc_Name, Doc_Type, Doc_Ext;
              return await axiosInstance // populate attachment(s) info to database
                .post(documentAttachment + "/attachment", {
                  attachments: uploadResponse.data.message.location.map(
                    (filename) => {
                      Doc_Name = filename.split(".");
                      Doc_Ext = Doc_Name.pop();
                      Doc_Type = Doc_Ext.toUpperCase();
                      Doc_Name = Doc_Name.join(".");
                      return {
                        Doc_Name,
                        Doc_Ext,
                        Doc_Type,
                        PrimaryRefID: ComplaintID,
                        Ref_Type: 112,
                      };
                    }
                  ),
                })
                .then((attachmentResponse) => {
                  if (attachmentResponse && attachmentResponse.data.success) {
                    // notification.success({
                    //   message: "Success",
                    //   description: "Done!",
                    // });
                    this.setState({ attachmentList: [] });
                    return true;
                  } else return false;
                })
                .catch(() => {
                  return false;
                });
            } else return false;
          } else return false;
        })
        .catch(() => {
          return false;
        });
    }
  };

  deleteAttachment = (ID) => {
    axiosInstance
      .delete(documentAttachment + "/attachment/" + ID)
      .then((res) => {
        if (res.data.success) {
          notification.success({
            message: "Success",
            description: "Deleted!",
          });
          let state = this.state;
          state.complaintData.ComplaintAttachments =
            state.complaintData.ComplaintAttachments.filter(
              (attachment) => attachment.AutoNo !== ID
            );
          this.setState(state);
        } else
          notification.success({
            message: "Fail",
            description: "Couldnot delete due to unknown reason(s)!",
          });
      })
      .catch((err) => {
        notification.success({
          message: "Error",
          description: "Couldnot delete due to unknown reason(s)!",
        });
      });
  };

  printReport = (query = "") => {
    this.setState({ printDataLoading: true, printIsDisabled: true });
    axiosInstance
      .get(complaint + "/report" + query, {
        signal: this.controller.signal,
      })
      .then((res) => {
        if ((res.data || {}).success === false) {
          this.setState({ printDataLoading: false, printIsDisabled: false });
          return notification.error({
            message: "Fail",
            description: res.data.message || "Something went wrong !",
          });
        }
        let element = document.createElement("a");
        element.setAttribute(
          "href",
          complaint +
            "/report?filename=" +
            res.data.message +
            "&token=" +
            encodedToken.value
        );
        element.setAttribute("target", "_blank");
        element.setAttribute("rel", "noopener noreferrer");
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        this.setState({ printDataLoading: false, printIsDisabled: false });
      })
      .catch((err) => {
        this.setState({ printDataLoading: false, printIsDisabled: false });
      });
  };

  onReset = async () => {
    this.setState(await this.getInitialState());
  };

  componentDidMount() {
    this._isMounted = true;
    this.controller = new AbortController();
    this.getInitialState().then((st) => {
      if (this._isMounted)
        this.setState(st, () => {
          if (
            this.props.location.state &&
            this.props.location.state.ComplaintID
          )
            this.initEditables(this.props.location.state.ComplaintID);
        });
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.controller.abort();
  }

  render() {
    return (
      <div>
        <Row style={{ margin: "10px 10px 10px 10px" }}>
          <Col span={4}></Col>
          <Col span={16} style={{ textAlign: "center" }}>
            <h3>Registration</h3>
          </Col>
          <Col span={4} style={{ textAlign: "right" }}></Col>
        </Row>
        <Spin
          spinning={this.state.dataIsLoading}
          tip="Fetching and populating data..."
        >
          <Row>
            <Col
              span={6}
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 12 }}
              lg={{ span: 8 }}
            >
              <Row>
                <Col span={24}>
                  <Divider style={{ marginTop: 0 }}>Property Info</Divider>
                </Col>
              </Row>
              <Row>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Company</label>
                    </Col>
                    <Col span={17}>
                      <Select
                        showSearch
                        disabled={this.state.complaintData.ComplaintID}
                        style={{ width: "100%" }}
                        placeholder="Select a Company"
                        optionFilterProp="children"
                        onChange={(val) =>
                          this.onChange(val || "adminCompany+-")
                        }
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                        value={
                          this.state.companyData.selectedValue
                            ? "adminCompany+-" +
                              this.state.companyData.selectedIndex +
                              "+-" +
                              this.state.companyData.selectedValue
                            : null
                        }
                      >
                        {this.state.companyData.list.map((company, index) => {
                          return (
                            <Select.Option
                              key={index}
                              value={
                                "adminCompany+-" +
                                index +
                                "+-" +
                                company.CompanyName
                              }
                            >
                              {company.CompanyName}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Division</label>
                    </Col>
                    <Col span={17}>
                      <Select
                        showSearch
                        disabled={this.state.complaintData.ComplaintID}
                        suffixIcon={this.state.divisionData.icon}
                        style={{ width: "100%" }}
                        placeholder="Select a Division"
                        optionFilterProp="children"
                        onChange={(val) => this.onChange(val || "division+-")}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                        value={
                          this.state.divisionData.selectedValue
                            ? "division+-" +
                              this.state.divisionData.selectedIndex +
                              "+-" +
                              this.state.divisionData.selectedValue
                            : null
                        }
                      >
                        {this.state.divisionData.list.map((division, index) => {
                          return (
                            <Select.Option
                              key={index}
                              value={
                                "division+-" + index + "+-" + division.UserName
                              }
                            >
                              {division.UserName}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Project</label>
                    </Col>
                    <Col span={17}>
                      <Select
                        showSearch
                        disabled={this.state.complaintData.ComplaintID}
                        suffixIcon={this.state.projectData.icon}
                        style={{ width: "100%" }}
                        placeholder="Select a Project"
                        optionFilterProp="children"
                        onChange={(val) => this.onChange(val || "project+-")}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                        value={
                          this.state.projectData.selectedValue
                            ? "project+-" +
                              this.state.projectData.selectedIndex +
                              "+-" +
                              this.state.projectData.selectedValue
                            : null
                        }
                      >
                        {this.state.projectData.list.map((project, index) => {
                          return (
                            <Select.Option
                              key={index}
                              value={
                                "project+-" + index + "+-" + project.ProjectName
                              }
                            >
                              {project.ProjectName}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Building</label>
                    </Col>
                    <Col span={17}>
                      <Select
                        showSearch
                        disabled={this.state.complaintData.ComplaintID}
                        suffixIcon={this.state.buildingData.icon}
                        style={{ width: "100%" }}
                        placeholder="Select a Building"
                        optionFilterProp="children"
                        onChange={(val) => this.onChange(val || "building+-")}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                        value={
                          this.state.buildingData.selectedValue
                            ? "building+-" +
                              this.state.buildingData.selectedIndex +
                              "+-" +
                              this.state.buildingData.selectedValue
                            : null
                        }
                      >
                        {this.state.buildingData.list
                          // .filter((buildi) =>
                          //   decodedToken.value.ContactID
                          //     ? buildi.incharge_id ===
                          //       decodedToken.value.ContactID
                          //     : true
                          // )
                          .map((building, index) => {
                            return (
                              <Select.Option
                                key={index}
                                value={
                                  "building+-" +
                                  index +
                                  "+-" +
                                  building.BuildingName
                                }
                              >
                                {building.BuildingName}
                              </Select.Option>
                            );
                          })}
                      </Select>
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Unit</label>
                    </Col>
                    <Col span={17}>
                      <Select
                        showSearch
                        disabled={this.state.complaintData.ComplaintID}
                        suffixIcon={this.state.unitData.icon}
                        style={{ width: "100%" }}
                        placeholder="Select a Unit"
                        optionFilterProp="children"
                        onChange={(val) => this.onChange(val || "unit+-")}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                        value={
                          this.state.unitData.selectedValue
                            ? "unit+-" +
                              this.state.unitData.selectedIndex +
                              "+-" +
                              this.state.unitData.selectedValue
                            : null
                        }
                      >
                        {this.state.unitData.list.map((unit, index) => {
                          return (
                            <Select.Option
                              key={index}
                              value={"unit+-" + index + "+-" + unit.UnitNo}
                            >
                              {unit.UnitNo}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Tenant</label>
                    </Col>
                    <Col span={17}>
                      <Input
                        placeholder="Tenant Name"
                        value={this.state.tenantData.Customer}
                        suffix={
                          this.state.tenantData.icon ||
                          this.state.tenantData.IsBlackListed ? (
                            <Tooltip title="Blacklisted">
                              <WarningOutlined
                                style={{ color: "red" }}
                                className="blacklist"
                              />
                            </Tooltip>
                          ) : null
                        }
                      ></Input>
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>TC No.</label>
                    </Col>
                    <Col span={17}>
                      <Input
                        placeholder="TCXXXX/XX/XX/XXXX"
                        value={this.state.tenantData.TCNo}
                        suffix={this.state.tenantData.icon}
                      ></Input>
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Tenant Contact</label>
                    </Col>
                    <Col span={8}>
                      <Input
                        placeholder="Phone"
                        value={this.state.tenantData.TenantContactNo}
                        suffix={this.state.tenantData.icon}
                      ></Input>
                    </Col>
                    <Col span={9}>
                      <Input
                        placeholder="Email"
                        value={this.state.tenantData.TenantEmail}
                        suffix={this.state.tenantData.icon}
                      ></Input>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col
              span={6}
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 12 }}
              lg={{ span: 8 }}
            >
              <Row>
                <Col span={24}>
                  <Divider style={{ marginTop: 0 }}>Job Reference</Divider>
                </Col>
              </Row>
              <Row>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Job No. (Sys)</label>
                    </Col>
                    <Col span={17}>
                      <Input
                        value={this.state.complaintData.ComplaintNo}
                      ></Input>
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Registration Date</label>
                    </Col>
                    <Col span={17}>
                      <DatePicker
                        disabled
                        format={
                          this.state.dateFormat + " " + this.state.timeFormat
                        }
                        allowClear={false}
                        style={{
                          width: "100%",
                        }}
                        onChange={(val) => {
                          let state = this.state;
                          state.complaintData.ComplaintDate = val;
                          this.setState(state);
                        }}
                        value={this.state.complaintData.ComplaintDate}
                      ></DatePicker>
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Main Status</label>
                    </Col>
                    <Col span={17}>
                      <Select
                        disabled={
                          !this.state.complaintData.ComplaintID ||
                          (this.state.complaintData.SupervisorID &&
                            this.state.complaintData.SupervisorID !==
                              decodedToken.value.ContactID)
                        }
                        // showSearch
                        style={{ width: "100%" }}
                        placeholder="Select a status"
                        optionFilterProp="children"
                        onChange={(val) => {
                          if (
                            this.state.complaintData.ComplaintID &&
                            val === "Closed"
                          ) {
                            this.setState({ signatureModalIsVisible: true });
                          }
                        }}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                        value={this.state.complaintData.OpenClosed}
                      >
                        <Select.Option key="Open" value="Open">
                          Open
                        </Select.Option>
                        <Select.Option key="Closed" value="Closed">
                          Closed
                        </Select.Option>
                      </Select>
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Sub Status</label>
                    </Col>
                    <Col span={17}>
                      <Select
                        disabled={
                          /** enable substatus for only supervisor/teamleader if exists */
                          this.state.complaintData.ComplaintID &&
                          this.state.complaintData.SupervisorID &&
                          this.state.complaintData.SupervisorID !==
                            decodedToken.value.ContactID
                        }
                        // showSearch
                        style={{ width: "100%" }}
                        placeholder="Select a substatus"
                        optionFilterProp="children"
                        onChange={(val) => this.onChange(val || "subStatus+-")}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                        value={
                          this.state.subStatusData.selectedValue
                            ? "subStatus+-" +
                              this.state.subStatusData.selectedIndex +
                              "+-" +
                              this.state.subStatusData.selectedValue
                            : null
                        }
                      >
                        {this.state.subStatusData.list.map((status, index) => {
                          return (
                            <Select.Option
                              key={index}
                              value={
                                "subStatus+-" + index + "+-" + status.UserName
                              }
                            >
                              {status.UserName}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Job Type</label>
                    </Col>
                    <Col span={17}>
                      <Select
                        showSearch
                        disabled={this.state.complaintData.ComplaintID}
                        style={{ width: "100%" }}
                        placeholder="Select a type"
                        optionFilterProp="children"
                        onChange={(val) =>
                          this.onChange(val || "complaintType+-")
                        }
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                        value={
                          this.state.complaintTypeData.selectedValue
                            ? "complaintType+-" +
                              this.state.complaintTypeData.selectedIndex +
                              "+-" +
                              this.state.complaintTypeData.selectedValue
                            : null
                        }
                      >
                        {this.state.complaintTypeData.list.map(
                          (category, index) => {
                            return (
                              <Select.Option
                                key={index}
                                value={
                                  "complaintType+-" +
                                  index +
                                  "+-" +
                                  category.UserName
                                }
                              >
                                {category.UserName}
                              </Select.Option>
                            );
                          }
                        )}
                      </Select>
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Priority</label>
                    </Col>
                    <Col span={17}>
                      <Select
                        // showSearch
                        disabled={this.state.complaintData.ComplaintID}
                        style={{ width: "100%" }}
                        placeholder="Select a priority"
                        optionFilterProp="children"
                        onChange={(val) => this.onChange(val || "priority+-")}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                        value={
                          this.state.priorityData.selectedValue
                            ? "priority+-" +
                              this.state.priorityData.selectedIndex +
                              "+-" +
                              this.state.priorityData.selectedValue
                            : null
                        }
                      >
                        {this.state.priorityData.list.map((priority, index) => {
                          return (
                            <Select.Option
                              key={index}
                              value={
                                "priority+-" + index + "+-" + priority.UserName
                              }
                            >
                              {priority.UserName}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Complaint Description</label>
                    </Col>
                    <Col span={17}>
                      <Input.TextArea
                        rows={3}
                        disabled={this.state.complaintData.ComplaintID}
                        placeholder="What went wrong?"
                        value={this.state.complaintData.Remarks}
                        onChange={(e) => {
                          let state = this.state;
                          state.complaintData.Remarks = e.target.value;
                          state.complaintData.ComplaintDetails[0].Description =
                            e.target.value;
                          this.setState(state);
                        }}
                      ></Input.TextArea>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col
              span={6}
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 24 }}
              lg={{ span: 8 }}
            >
              <Row>
                <Col span={24}>
                  <Divider style={{ marginTop: 0 }}>Others</Divider>
                </Col>
              </Row>
              <Row>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Tabs
                    defaultActiveKey="0"
                    activeKey={this.state.tabData.activeKey}
                    onChange={(key) => {
                      let state = this.state;
                      state.tabData.activeKey = String(key);
                      this.setState(state);
                    }}
                    style={{
                      padding: 5,
                      // borderTop: "1px solid #f0f0f0",
                      // maxHeight: 200,
                    }}
                  >
                    <Tabs.TabPane tab="Job Assignment" key="1">
                      <Row>
                        <Col
                          span={6}
                          xs={{ span: 24 }}
                          sm={{ span: 24 }}
                          md={{ span: 24 }}
                          lg={{ span: 24 }}
                        >
                          <Row style={{ marginBottom: 10 }} gutter={8}>
                            <Col span={6} style={{ textAlign: "right" }}>
                              <label>Entered by / Date</label>
                            </Col>
                            <Col span={10}>
                              <Tooltip
                                title={
                                  this.state.complaintData
                                    .Entered_Party_Type === "T"
                                    ? "Tenant"
                                    : "Employee"
                                }
                              >
                                <Input
                                  value={
                                    this.state.complaintData.Creator
                                      ? this.state.complaintData.Creator
                                          .User_Name ||
                                        decodedToken.value.User_Name
                                      : decodedToken.value.User_Name
                                  }
                                ></Input>
                              </Tooltip>
                            </Col>
                            <Col span={8}>
                              <Input
                                value={
                                  this.state.complaintData.DateEntered ||
                                  new Date().toISOString().split("T")[0]
                                }
                              ></Input>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          span={6}
                          xs={{ span: 24 }}
                          sm={{ span: 24 }}
                          md={{ span: 24 }}
                          lg={{ span: 24 }}
                        >
                          <Row style={{ marginBottom: 10 }} gutter={8}>
                            <Col span={6} style={{ textAlign: "right" }}>
                              <label>Despatched To</label>
                            </Col>
                            <Col span={18}>
                              <Select
                                // disabled={
                                //   !this.state.complaintData.Despatched ||
                                //   !this.state.teamData.selectedValue
                                // }
                                showSearch
                                style={{ width: "100%" }}
                                placeholder="Select a leader"
                                optionFilterProp="children"
                                onChange={(val) =>
                                  this.onChange(val || "leader+-")
                                }
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                filterSort={(optionA, optionB) =>
                                  optionA.children
                                    .toLowerCase()
                                    .localeCompare(
                                      optionB.children.toLowerCase()
                                    )
                                }
                                value={
                                  this.state.leaderData.selectedValue
                                    ? "leader+-" +
                                      this.state.leaderData.selectedIndex +
                                      "+-" +
                                      this.state.leaderData.selectedValue
                                    : null
                                }
                              >
                                {this.state.leaderData.list.map(
                                  (leader, index) => {
                                    return (
                                      <Select.Option
                                        key={index}
                                        value={
                                          "leader+-" +
                                          index +
                                          "+-" +
                                          leader.ContactName
                                        }
                                      >
                                        {leader.ContactName}
                                      </Select.Option>
                                    );
                                  }
                                )}
                              </Select>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane
                      tab="Manpower"
                      key="2"
                      disabled={
                        !this.state.complaintData.ComplaintID ||
                        !this.state.complaintData.Despatched ||
                        (this.state.complaintData.SupervisorID &&
                          this.state.complaintData.SupervisorID !==
                            decodedToken.value.ContactID)
                      }
                      style={{
                        maxHeight: 265,
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      <Row gutter={8}>
                        <Col
                          span={6}
                          xs={{ span: 24 }}
                          sm={{ span: 24 }}
                          md={{ span: 8 }}
                          lg={{ span: 24 }}
                        >
                          <Row>
                            <Col
                              span={6}
                              xs={{ span: 24 }}
                              sm={{ span: 24 }}
                              md={{ span: 24 }}
                              lg={{ span: 24 }}
                            >
                              <Row gutter={8}>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 6 }}
                                  lg={{ span: 24 }}
                                >
                                  <label>Designation</label>
                                </Col>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 18 }}
                                  lg={{ span: 24 }}
                                >
                                  <Select
                                    showSearch
                                    style={{ width: "100%" }}
                                    placeholder="Select a designation"
                                    optionFilterProp="children"
                                    onChange={(val) =>
                                      this.onChange(val || "designation+-")
                                    }
                                    filterOption={(input, option) =>
                                      option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>
                                      optionA.children
                                        .toLowerCase()
                                        .localeCompare(
                                          optionB.children.toLowerCase()
                                        )
                                    }
                                    value={
                                      this.state.designationData.selectedValue
                                        ? "designation+-" +
                                          this.state.designationData
                                            .selectedIndex +
                                          "+-" +
                                          this.state.designationData
                                            .selectedValue
                                        : null
                                    }
                                  >
                                    {this.state.designationData.list.map(
                                      (designation, index) => {
                                        return (
                                          <Select.Option
                                            key={index}
                                            value={
                                              "designation+-" +
                                              index +
                                              "+-" +
                                              designation.UserName
                                            }
                                          >
                                            {designation.UserName}
                                          </Select.Option>
                                        );
                                      }
                                    )}
                                  </Select>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row style={{ marginTop: 10 }}>
                            <Col
                              span={6}
                              xs={{ span: 24 }}
                              sm={{ span: 24 }}
                              md={{ span: 24 }}
                              lg={{ span: 24 }}
                            >
                              <Row gutter={8}>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 6 }}
                                  lg={{ span: 24 }}
                                >
                                  <label>Employee</label>
                                </Col>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 18 }}
                                  lg={{ span: 24 }}
                                >
                                  <Select
                                    showSearch
                                    suffixIcon={this.state.employeeData.icon}
                                    style={{ width: "100%" }}
                                    placeholder="Select an employee"
                                    optionFilterProp="children"
                                    onChange={(val) =>
                                      this.onChange(val || "employee+-")
                                    }
                                    filterOption={(input, option) =>
                                      option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>
                                      optionA.children
                                        .toLowerCase()
                                        .localeCompare(
                                          optionB.children.toLowerCase()
                                        )
                                    }
                                    value={
                                      this.state.employeeData.selectedValue
                                        ? "employee+-" +
                                          this.state.employeeData
                                            .selectedIndex +
                                          "+-" +
                                          this.state.employeeData.selectedValue
                                        : null
                                    }
                                  >
                                    {this.state.employeeData.list.map(
                                      (employee, index) => {
                                        return (
                                          <Select.Option
                                            key={index}
                                            value={
                                              "employee+-" +
                                              index +
                                              "+-" +
                                              employee.ContactName
                                            }
                                          >
                                            {employee.ContactName}
                                          </Select.Option>
                                        );
                                      }
                                    )}
                                  </Select>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row style={{ marginTop: 10 }}>
                            <Col
                              span={6}
                              xs={{ span: 24 }}
                              sm={{ span: 24 }}
                              md={{ span: 24 }}
                              lg={{ span: 24 }}
                            >
                              <Row gutter={8}>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 6 }}
                                  lg={{ span: 24 }}
                                >
                                  <label>No. of hours</label>
                                </Col>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 18 }}
                                  lg={{ span: 24 }}
                                >
                                  <Input
                                    type="number"
                                    value={this.state.noOfHours.selectedValue}
                                    onChange={(value) => {
                                      this.setState({
                                        noOfHours: {
                                          selectedValue:
                                            Number(value.target.value) || "",
                                        },
                                        manpowerAmount: {
                                          selectedValue:
                                            (Number(
                                              this.state.manpowerRate
                                                .selectedValue
                                            ) || 0) *
                                            (Number(value.target.value) || 0),
                                        },
                                      });
                                    }}
                                  ></Input>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row style={{ marginTop: 10 }}>
                            <Col
                              span={6}
                              xs={{ span: 24 }}
                              sm={{ span: 24 }}
                              md={{ span: 24 }}
                              lg={{ span: 24 }}
                            >
                              <Row gutter={8}>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 6 }}
                                  lg={{ span: 24 }}
                                >
                                  <label>Rate/Amount</label>
                                </Col>
                                <Col
                                  span={6}
                                  xs={{ span: 10 }}
                                  sm={{ span: 10 }}
                                  md={{ span: 9 }}
                                  lg={{ span: 10 }}
                                >
                                  <Input
                                    type="number"
                                    suffix={this.state.manpowerRate.icon}
                                    value={
                                      this.state.manpowerRate.selectedValue
                                    }
                                    onChange={(value) => {
                                      this.setState({
                                        manpowerRate: {
                                          selectedValue:
                                            Number(value.target.value) || "",
                                        },
                                        manpowerAmount: {
                                          selectedValue:
                                            (Number(
                                              this.state.noOfHours.selectedValue
                                            ) || 0) *
                                            (Number(value.target.value) || 0),
                                        },
                                      });
                                    }}
                                  ></Input>
                                </Col>
                                <Col
                                  span={6}
                                  xs={{ span: 14 }}
                                  sm={{ span: 14 }}
                                  md={{ span: 9 }}
                                  lg={{ span: 14 }}
                                >
                                  <Input
                                    type="number"
                                    value={
                                      this.state.manpowerAmount.selectedValue
                                    }
                                    onChange={(e) => {
                                      this.setState({
                                        manpowerAmount: {
                                          selectedValue:
                                            Number(e.target.value) || 0,
                                        },
                                      });
                                    }}
                                  ></Input>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row style={{ marginTop: 10 }}>
                            <Col
                              span={6}
                              xs={{ span: 24 }}
                              sm={{ span: 24 }}
                              md={{ span: 24 }}
                              lg={{ span: 24 }}
                            >
                              <Row gutter={8}>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 6 }}
                                  lg={{ span: 24 }}
                                >
                                  <label>Description</label>
                                </Col>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 18 }}
                                  lg={{ span: 24 }}
                                >
                                  <Input.TextArea
                                    rows={1}
                                    type="number"
                                    onChange={(e) => {
                                      this.setState({
                                        manpowerDescription: {
                                          selectedValue: e.target.value,
                                        },
                                      });
                                    }}
                                    value={
                                      this.state.manpowerDescription
                                        .selectedValue
                                    }
                                  ></Input.TextArea>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row style={{ marginTop: 10 }}>
                            <Col
                              span={6}
                              xs={{ span: 24 }}
                              sm={{ span: 24 }}
                              md={{ span: 24 }}
                              lg={{ span: 24 }}
                            >
                              <Row gutter={8}>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 24 }}
                                  lg={{ span: 24 }}
                                >
                                  <Button
                                    style={{ width: "100%" }}
                                    onClick={() => {
                                      if (
                                        !this.state.designationData
                                          .selectedValue
                                      )
                                        return message.error(
                                          "Please select a designation!"
                                        );
                                      if (
                                        !this.state.employeeData.selectedValue
                                      )
                                        return message.error(
                                          "Please select an employee!"
                                        );
                                      if (!this.state.noOfHours.selectedValue)
                                        return message.error(
                                          "Please enter no. of hours!"
                                        );
                                      let state = this.state;
                                      state.complaintData.ComplaintManpowers = [
                                        ...state.complaintData
                                          .ComplaintManpowers,
                                        {
                                          key: state.complaintData
                                            .ComplaintManpowers.length,
                                          DesignationID:
                                            this.state.designationData.list[
                                              this.state.designationData
                                                .selectedIndex
                                            ].DesignationID,
                                          Contact: {
                                            ContactName:
                                              this.state.employeeData.list[
                                                this.state.employeeData
                                                  .selectedIndex
                                              ].ContactName,
                                          },
                                          EmployeeID:
                                            this.state.employeeData.list[
                                              this.state.employeeData
                                                .selectedIndex
                                            ].ContactID,
                                          Hours:
                                            this.state.noOfHours.selectedValue,
                                          Rate: this.state.manpowerRate
                                            .selectedValue,
                                          Amount:
                                            this.state.manpowerAmount
                                              .selectedValue,
                                          Description:
                                            this.state.manpowerDescription
                                              .selectedValue,
                                        },
                                      ];
                                      this.setState(state);
                                    }}
                                  >
                                    Add Manpower
                                  </Button>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          span={6}
                          xs={{ span: 24 }}
                          sm={{ span: 24 }}
                          md={{ span: 0 }}
                          lg={{ span: 24 }}
                          style={{ marginTop: 30 }}
                        ></Col>
                        <Col
                          span={6}
                          xs={{ span: 24 }}
                          sm={{ span: 24 }}
                          md={{ span: 16 }}
                          lg={{ span: 24 }}
                        >
                          <Table
                            scroll={{
                              scrollToFirstRowOnChange: false,
                              x: 200,
                              y: 200,
                            }}
                            align="center"
                            size="small"
                            columns={this.manpowerColumns}
                            dataSource={
                              this.state.complaintData.ComplaintManpowers
                            }
                            style={{
                              height: "100%",
                            }}
                            pagination={false}
                          />
                        </Col>
                      </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane
                      tab="Materials"
                      key="3"
                      disabled={
                        !this.state.complaintData.ComplaintID ||
                        !this.state.complaintData.Despatched ||
                        (this.state.complaintData.SupervisorID &&
                          this.state.complaintData.SupervisorID !==
                            decodedToken.value.ContactID)
                      }
                      style={{
                        maxHeight: 265,
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      <Row gutter={8}>
                        <Col
                          span={6}
                          xs={{ span: 24 }}
                          sm={{ span: 24 }}
                          md={{ span: 8 }}
                          lg={{ span: 24 }}
                        >
                          <Row>
                            <Col
                              span={6}
                              xs={{ span: 24 }}
                              sm={{ span: 24 }}
                              md={{ span: 24 }}
                              lg={{ span: 24 }}
                            >
                              <Row gutter={8}>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 6 }}
                                  lg={{ span: 24 }}
                                >
                                  <label>Category</label>
                                </Col>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 18 }}
                                  lg={{ span: 24 }}
                                >
                                  <Select
                                    showSearch
                                    style={{ width: "100%" }}
                                    placeholder="Select a material category"
                                    optionFilterProp="children"
                                    onChange={(val) =>
                                      this.onChange(val || "matCat+-")
                                    }
                                    filterOption={(input, option) =>
                                      option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>
                                      optionA.children
                                        .toLowerCase()
                                        .localeCompare(
                                          optionB.children.toLowerCase()
                                        )
                                    }
                                    value={
                                      this.state.materialCategoryData
                                        .selectedValue
                                        ? "matCat+-" +
                                          this.state.materialCategoryData
                                            .selectedIndex +
                                          "+-" +
                                          this.state.materialCategoryData
                                            .selectedValue
                                        : null
                                    }
                                  >
                                    {this.state.materialCategoryData.list.map(
                                      (category, index) => {
                                        return (
                                          <Select.Option
                                            key={index}
                                            value={
                                              "matCat+-" +
                                              index +
                                              "+-" +
                                              category.MaterialName
                                            }
                                          >
                                            {category.MaterialName}
                                          </Select.Option>
                                        );
                                      }
                                    )}
                                  </Select>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row style={{ marginTop: 10 }}>
                            <Col
                              span={6}
                              xs={{ span: 24 }}
                              sm={{ span: 24 }}
                              md={{ span: 24 }}
                              lg={{ span: 24 }}
                            >
                              <Row gutter={8}>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 6 }}
                                  lg={{ span: 24 }}
                                >
                                  <label>Item</label>
                                </Col>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 18 }}
                                  lg={{ span: 24 }}
                                >
                                  <Select
                                    showSearch
                                    style={{ width: "100%" }}
                                    placeholder="Select an item"
                                    optionFilterProp="children"
                                    onChange={(val) =>
                                      this.onChange(val || "matItem+-")
                                    }
                                    filterOption={(input, option) =>
                                      option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>
                                      optionA.children
                                        .toLowerCase()
                                        .localeCompare(
                                          optionB.children.toLowerCase()
                                        )
                                    }
                                    value={
                                      this.state.materialItemData.selectedValue
                                        ? "matItem+-" +
                                          this.state.materialItemData
                                            .selectedIndex +
                                          "+-" +
                                          this.state.materialItemData
                                            .selectedValue
                                        : null
                                    }
                                  >
                                    {this.state.materialItemData.list.map(
                                      (item, index) => {
                                        return (
                                          <Select.Option
                                            key={index}
                                            value={
                                              "matItem+-" +
                                              index +
                                              "+-" +
                                              item.MaterialName
                                            }
                                          >
                                            {item.MaterialName}
                                          </Select.Option>
                                        );
                                      }
                                    )}
                                  </Select>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row style={{ marginTop: 10 }}>
                            <Col
                              span={6}
                              xs={{ span: 24 }}
                              sm={{ span: 24 }}
                              md={{ span: 24 }}
                              lg={{ span: 24 }}
                            >
                              <Row gutter={8}>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 6 }}
                                  lg={{ span: 24 }}
                                >
                                  <label>Qty.</label>
                                </Col>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 18 }}
                                  lg={{ span: 24 }}
                                >
                                  <Input
                                    type="number"
                                    value={this.state.qty.selectedValue}
                                    onChange={(value) => {
                                      this.setState({
                                        qty: {
                                          selectedValue:
                                            Number(value.target.value) || "",
                                        },
                                        materialAmount: {
                                          selectedValue:
                                            (Number(
                                              this.state.materialRate
                                                .selectedValue
                                            ) || 0) *
                                            (Number(value.target.value) || 0),
                                        },
                                      });
                                    }}
                                  ></Input>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row style={{ marginTop: 10 }}>
                            <Col
                              span={6}
                              xs={{ span: 24 }}
                              sm={{ span: 24 }}
                              md={{ span: 24 }}
                              lg={{ span: 24 }}
                            >
                              <Row gutter={8}>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 6 }}
                                  lg={{ span: 24 }}
                                >
                                  <label>Rate/Amount</label>
                                </Col>
                                <Col
                                  span={6}
                                  xs={{ span: 10 }}
                                  sm={{ span: 10 }}
                                  md={{ span: 9 }}
                                  lg={{ span: 10 }}
                                >
                                  <Input
                                    type="number"
                                    value={
                                      this.state.materialRate.selectedValue
                                    }
                                    onChange={(value) => {
                                      this.setState({
                                        materialRate: {
                                          selectedValue:
                                            Number(value.target.value) || "",
                                        },
                                        materialAmount: {
                                          selectedValue:
                                            (Number(
                                              this.state.qty.selectedValue
                                            ) || 0) *
                                            (Number(value.target.value) || 0),
                                        },
                                      });
                                    }}
                                  ></Input>
                                </Col>
                                <Col
                                  span={6}
                                  xs={{ span: 14 }}
                                  sm={{ span: 14 }}
                                  md={{ span: 9 }}
                                  lg={{ span: 14 }}
                                >
                                  <Input
                                    type="number"
                                    value={
                                      this.state.materialAmount.selectedValue
                                    }
                                    onChange={(e) => {
                                      this.setState({
                                        materialAmount: {
                                          selectedValue:
                                            Number(e.target.value) || 0,
                                        },
                                      });
                                    }}
                                  ></Input>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row style={{ marginTop: 10 }}>
                            <Col
                              span={6}
                              xs={{ span: 24 }}
                              sm={{ span: 24 }}
                              md={{ span: 24 }}
                              lg={{ span: 24 }}
                            >
                              <Row gutter={8}>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 6 }}
                                  lg={{ span: 24 }}
                                >
                                  <label>Description</label>
                                </Col>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 18 }}
                                  lg={{ span: 24 }}
                                >
                                  <Input.TextArea
                                    rows={1}
                                    type="number"
                                    onChange={(e) => {
                                      this.setState({
                                        materialDescription: {
                                          selectedValue: e.target.value,
                                        },
                                      });
                                    }}
                                    value={
                                      this.state.materialDescription
                                        .selectedValue
                                    }
                                  ></Input.TextArea>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row style={{ marginTop: 10 }}>
                            <Col
                              span={6}
                              xs={{ span: 24 }}
                              sm={{ span: 24 }}
                              md={{ span: 24 }}
                              lg={{ span: 24 }}
                            >
                              <Row gutter={8}>
                                <Col
                                  span={6}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 24 }}
                                  lg={{ span: 24 }}
                                >
                                  <Button
                                    style={{ width: "100%" }}
                                    onClick={() => {
                                      if (
                                        !this.state.materialCategoryData
                                          .selectedValue
                                      )
                                        return message.error(
                                          "Please select a material category!"
                                        );
                                      if (
                                        !this.state.materialItemData
                                          .selectedValue
                                      )
                                        return message.error(
                                          "Please select a material item!"
                                        );
                                      if (!this.state.qty.selectedValue)
                                        return message.error(
                                          "Please enter quantity!"
                                        );
                                      let state = this.state;
                                      state.complaintData.ComplaintMaterials = [
                                        ...state.complaintData
                                          .ComplaintMaterials,
                                        {
                                          key: state.complaintData
                                            .ComplaintMaterials.length,
                                          MatCatId:
                                            this.state.materialCategoryData
                                              .list[
                                              this.state.materialCategoryData
                                                .selectedIndex
                                            ].MatCategoryID,
                                          MatItemID:
                                            this.state.materialItemData.list[
                                              this.state.materialItemData
                                                .selectedIndex
                                            ].MatItemID,
                                          MaterialItem: {
                                            MaterialName:
                                              this.state.materialItemData.list[
                                                this.state.materialItemData
                                                  .selectedIndex
                                              ].MaterialName,
                                          },
                                          Qty: this.state.qty.selectedValue,
                                          Rate: this.state.materialRate
                                            .selectedValue,
                                          Amount:
                                            this.state.materialAmount
                                              .selectedValue,
                                          Billed: this.state.materialBilled,
                                          Description:
                                            this.state.materialDescription
                                              .selectedValue,
                                        },
                                      ];
                                      this.setState(state);
                                    }}
                                  >
                                    Add Material
                                  </Button>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          span={6}
                          xs={{ span: 24 }}
                          sm={{ span: 24 }}
                          md={{ span: 0 }}
                          lg={{ span: 24 }}
                          style={{ marginTop: 30 }}
                        ></Col>
                        <Col
                          span={6}
                          xs={{ span: 24 }}
                          sm={{ span: 24 }}
                          md={{ span: 16 }}
                          lg={{ span: 24 }}
                        >
                          <Table
                            scroll={{
                              scrollToFirstRowOnChange: false,
                              x: 200,
                              y: 200,
                            }}
                            align="center"
                            size="small"
                            columns={this.materialColumns}
                            dataSource={
                              this.state.complaintData.ComplaintMaterials
                            }
                            style={{
                              height: "100%",
                            }}
                            pagination={false}
                          />
                        </Col>
                      </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Feedback" key="4">
                      <Row gutter={8}>
                        <Col span={6}>
                          <label>Feedback</label>
                        </Col>
                        <Col span={18}>
                          <span style={{ width: "100%" }}>
                            <Rate
                              disabled
                              style={{ width: "100%", color: "green" }}
                              tooltips={this.state.feedbackRate.list}
                              onChange={(value) => {
                                let state = this.state;
                                state.complaintData.TenantFeedback =
                                  this.state.feedbackRate.list[value - 1];
                                state.complaintData.FeedbackPoints = value;
                                this.setState(state);
                              }}
                              value={this.state.complaintData.FeedbackPoints}
                              character={({ index }) =>
                                this.state.feedbackRate.customIcons[index + 1]
                              }
                            />
                          </span>
                        </Col>
                      </Row>
                      <Row gutter={8} style={{ marginTop: 20 }}>
                        <Col span={6}>
                          <label>Description</label>
                        </Col>
                        <Col span={18}>
                          <Input.TextArea
                            // disabled
                            onChange={(e) => {
                              //   let state = this.state;
                              //   state.complaintData.Feedback = e.target.value;
                              //   this.setState(state);
                            }}
                            value={this.state.complaintData.Feedback}
                          ></Input.TextArea>
                        </Col>
                      </Row>
                      <Row gutter={8} style={{ marginTop: 20 }}>
                        <Col span={6}>
                          <label>Supervisor Remarks</label>
                        </Col>
                        <Col span={18}>
                          <Input.TextArea
                            rows={3}
                            onChange={(e) => {
                              let state = this.state;
                              state.complaintData.SolutionDescription =
                                e.target.value;
                              this.setState(state);
                            }}
                            value={this.state.complaintData.SolutionDescription}
                          ></Input.TextArea>
                        </Col>
                      </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane
                      tab="Attachments"
                      key="5"
                      style={{
                        maxHeight: 265,
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      <Row>
                        <Col
                          span={6}
                          xs={{ span: 24 }}
                          sm={{ span: 24 }}
                          md={{ span: 24 }}
                          lg={{ span: 24 }}
                        >
                          <Row>
                            <Col span={24}>
                              <Upload.Dragger
                                style={{
                                  width: "100%",
                                  maxHeight: 150,
                                }}
                                onRemove={(file) => {
                                  file.originalName =
                                    file.originalName || file.name;
                                  this.setState((state) => {
                                    const index =
                                      state.attachmentList.indexOf(file);
                                    const newFileList =
                                      state.attachmentList.slice();
                                    newFileList.splice(index, 1);
                                    return {
                                      attachmentList: newFileList,
                                    };
                                  });
                                }}
                                beforeUpload={(file) => {
                                  file.originalName =
                                    file.originalName || file.name;
                                  if (
                                    this.state.attachmentList
                                      .slice(0, 1)
                                      .reduce(
                                        (prev, curr) => ({
                                          size: prev.size + curr.size,
                                        }),
                                        { size: 0 }
                                      ).size +
                                      file.size >
                                    10485760
                                  )
                                    return message.error(
                                      "Total combined file size cannot be greater than 10MB !"
                                    );
                                  let filereader = new FileReader();
                                  filereader.onloadend = () => {
                                    let state = this.state;
                                    state.attachmentList = [
                                      ...state.attachmentList.slice(0, 1),
                                      file,
                                    ];
                                    this.setState(state);
                                  };
                                  filereader.readAsDataURL(file);
                                  return false;
                                }}
                                multiple
                                maxCount={2}
                                accept=".jpg,.jpeg"
                                fileList={this.state.attachmentList}
                              >
                                <p className="ant-upload-drag-icon">
                                  <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">
                                  Click or drag file to this area to upload
                                </p>
                                <p className="ant-upload-hint">
                                  Max files: 2, Max size: 10MB, Types: JPEG, JPG
                                </p>
                              </Upload.Dragger>
                            </Col>
                          </Row>
                          {/* <Row style={{ marginTop: 10 }}>
                        <Col span={24}>
                          <Button
                            disabled={!this.state.attachmentList.length}
                            icon={<UploadOutlined />}
                            style={{ width: "100%" }}
                            onClick={this.uploadAttachments}
                          >
                            Upload
                          </Button>
                        </Col>
                      </Row> */}
                        </Col>
                      </Row>
                      <Row>
                        <Col span={24}>
                          <Divider
                            orientation="center"
                            style={{ fontSize: 14 }}
                          ></Divider>
                        </Col>
                      </Row>
                      {this.state.complaintData.ComplaintAttachments.length ? (
                        <Row gutter={8}>
                          {this.state.complaintData.ComplaintAttachments.map(
                            (attachment) => {
                              switch (attachment.Doc_Ext.toLowerCase()) {
                                case "jpg":
                                case "jpeg":
                                case "png":
                                  return (
                                    <Col
                                      span={8}
                                      xs={{ span: 24 }}
                                      sm={{ span: 24 }}
                                      md={{ span: 12 }}
                                      lg={{ span: 12 }}
                                      style={{ marginTop: 10 }}
                                    >
                                      <Row>
                                        <Col
                                          span={24}
                                          style={{ textAlign: "right" }}
                                        >
                                          <Popconfirm
                                            title="Are you sure to delete this attachment?"
                                            onConfirm={() => {
                                              if (
                                                this.state.complaintData.closed
                                              )
                                                return;
                                              this.deleteAttachment(
                                                attachment.AutoNo
                                              );
                                            }}
                                          >
                                            <DeleteOutlined
                                              style={{
                                                color: this.state.complaintData
                                                  .closed
                                                  ? "gray"
                                                  : "red",
                                              }}
                                            />
                                          </Popconfirm>
                                        </Col>
                                        <Col span={24}>
                                          <Tooltip
                                            title={
                                              "Filename: " +
                                              attachment.Doc_Name.split("-")
                                                .slice(4)
                                                .join("-")
                                            }
                                          >
                                            <Image
                                              width="100%"
                                              height={200}
                                              src={
                                                baseUrl +
                                                "/uploads?location=" +
                                                attachment.Doc_Name +
                                                "." +
                                                attachment.Doc_Ext +
                                                "&tj=" +
                                                generateToken()
                                              }
                                              fallback="data:image/png;base64,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"
                                            ></Image>
                                          </Tooltip>
                                        </Col>
                                      </Row>
                                    </Col>
                                  );
                                case "mp4":
                                case "webm":
                                case "ogg":
                                  return (
                                    <Col
                                      span={8}
                                      xs={{ span: 24 }}
                                      sm={{ span: 24 }}
                                      md={{ span: 12 }}
                                      lg={{ span: 12 }}
                                      style={{ marginTop: 10 }}
                                    >
                                      <Row>
                                        <Col
                                          span={24}
                                          style={{ textAlign: "right" }}
                                        >
                                          <Popconfirm
                                            title="Are you sure to delete this attachment?"
                                            onConfirm={() =>
                                              this.deleteAttachment(
                                                attachment.AutoNo
                                              )
                                            }
                                          >
                                            <DeleteOutlined
                                              style={{ color: "red" }}
                                            />
                                          </Popconfirm>
                                        </Col>
                                        <Col span={24}>
                                          <Tooltip
                                            title={
                                              "Filename: " +
                                              attachment.Doc_Name.split("-")
                                                .slice(4)
                                                .join("-")
                                            }
                                          >
                                            <video
                                              width="100%"
                                              height={200}
                                              controls
                                              src={
                                                baseUrl +
                                                "/uploads?location=" +
                                                attachment.Doc_Name +
                                                "." +
                                                attachment.Doc_Ext +
                                                "&tj=" +
                                                generateToken()
                                              }
                                            >
                                              Your browser does not support the
                                              video element.
                                            </video>
                                          </Tooltip>
                                        </Col>
                                      </Row>
                                    </Col>
                                  );
                                case "mp3":
                                case "wav":
                                  return (
                                    <Col
                                      span={8}
                                      xs={{ span: 24 }}
                                      sm={{ span: 24 }}
                                      md={{ span: 12 }}
                                      lg={{ span: 12 }}
                                      style={{ marginTop: 10 }}
                                    >
                                      <Row>
                                        <Col
                                          span={24}
                                          style={{ textAlign: "right" }}
                                        >
                                          <Popconfirm
                                            title="Are you sure to delete this attachment?"
                                            onConfirm={() =>
                                              this.deleteAttachment(
                                                attachment.AutoNo
                                              )
                                            }
                                          >
                                            <DeleteOutlined
                                              style={{ color: "red" }}
                                            />
                                          </Popconfirm>
                                        </Col>
                                        <Col span={24}>
                                          <Tooltip
                                            title={
                                              "Filename: " +
                                              attachment.Doc_Name.split("-")
                                                .slice(4)
                                                .join("-")
                                            }
                                          >
                                            <audio
                                              width="100%"
                                              height={200}
                                              controls
                                              src={
                                                baseUrl +
                                                "/uploads?location=" +
                                                attachment.Doc_Name +
                                                "." +
                                                attachment.Doc_Ext +
                                                "&tj=" +
                                                generateToken()
                                              }
                                            >
                                              Your browser does not support the
                                              audio element.
                                            </audio>
                                          </Tooltip>
                                        </Col>
                                      </Row>
                                    </Col>
                                  );
                                default:
                                  return (
                                    <Col
                                      span={8}
                                      xs={{ span: 24 }}
                                      sm={{ span: 24 }}
                                      md={{ span: 12 }}
                                      lg={{ span: 12 }}
                                      style={{
                                        textAlign: "center",
                                        marginTop: 10,
                                      }}
                                    >
                                      <Row>
                                        <Col
                                          span={24}
                                          style={{ textAlign: "right" }}
                                        >
                                          <Popconfirm
                                            title="Are you sure to delete this attachment?"
                                            onConfirm={() =>
                                              this.deleteAttachment(
                                                attachment.AutoNo
                                              )
                                            }
                                          >
                                            <DeleteOutlined
                                              style={{ color: "red" }}
                                            />
                                          </Popconfirm>
                                        </Col>
                                        <Col span={24}>
                                          <Tooltip
                                            title={
                                              "Filename: " +
                                              attachment.Doc_Name.split("-")
                                                .slice(4)
                                                .join("-")
                                            }
                                          >
                                            <div
                                              key={"div" + attachment.AutoNo}
                                              style={{
                                                position: "relative",
                                                textAlign: "center",
                                              }}
                                            >
                                              <FileOutlined
                                                style={{ fontSize: "200px" }}
                                                onClick={() => {
                                                  let a =
                                                    document.createElement("a");
                                                  a.href =
                                                    baseUrl +
                                                    "/uploads?location=" +
                                                    attachment.Doc_Name +
                                                    "." +
                                                    attachment.Doc_Ext +
                                                    "&tj=" +
                                                    generateToken();
                                                  a.target = "_blank";
                                                  a.download =
                                                    attachment.Doc_Name.split(
                                                      "-"
                                                    )
                                                      .slice(4)
                                                      .join("-");
                                                  a.click();
                                                }}
                                              />
                                              <label
                                                key={
                                                  "label" + attachment.AutoNo
                                                }
                                                style={{
                                                  position: "absolute",
                                                  top: "50%",
                                                  left: "50%",
                                                  transform:
                                                    "translate(-50%, -50%)",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {attachment.Doc_Type}
                                              </label>
                                            </div>
                                          </Tooltip>
                                        </Col>
                                      </Row>
                                    </Col>
                                  );
                              }
                            }
                          )}
                        </Row>
                      ) : (
                        <Row>
                          <Col span={4}></Col>
                          <Col span={16}>
                            <Empty />
                          </Col>
                          <Col span={4}></Col>
                        </Row>
                      )}
                    </Tabs.TabPane>
                  </Tabs>
                </Col>
              </Row>
            </Col>
            <Col
              span={6}
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 24 }}
              lg={{ span: 24 }}
            >
              <Row
                gutter={[8, 8]}
                style={{
                  marginTop: 15,
                  marginBottom: 10,
                  marginLeft: 10,
                  marginRight: 10,
                }}
              >
                <Col
                  span={6}
                  xs={{ span: 12 }}
                  sm={{ span: 8 }}
                  md={{ span: 10 }}
                  lg={{ span: 10 }}
                >
                  <Spin spinning={this.state.dataBeingSaved} tip="">
                    <Button
                      icon={<SaveOutlined style={{ color: "green" }} />}
                      style={{ width: "100%", borderRadius: 20 }}
                      disabled={
                        this.state.createUpdateDisabled ||
                        this.state.complaintData.closed
                      }
                      onClick={() => {
                        // validate data
                        if (this.validateWritable()) {
                          this.setState({
                            dataBeingSaved: true,
                            createUpdateDisabled: true,
                          });
                          (this.state.complaintData.ComplaintID
                            ? axiosInstance.put(complaint, {
                                ...this.state.complaintData,
                                ComplaintDate:
                                  this.state.complaintData.ComplaintDate.toISOString().split(
                                    "T"
                                  )[0],
                                DateEdited: new Date()
                                  .toISOString()
                                  .split("T")[0],
                              })
                            : axiosInstance.post(complaint, {
                                ...this.state.complaintData,
                                ComplaintDate:
                                  this.state.complaintData.ComplaintDate.toISOString().split(
                                    "T"
                                  )[0],
                              })
                          )
                            .then((res) => {
                              if (res.data.success) {
                                this.uploadAttachments(res.data.message).then(
                                  (uploaded) => {
                                    this.initEditables(res.data.message);
                                    notification.success({
                                      message: "Success",
                                      description: "Done!",
                                    });
                                  }
                                );
                              } else
                                notification.error({
                                  message: "Fail",
                                  description:
                                    res.data.message || "Something went wrong!",
                                });
                              this.setState({
                                dataBeingSaved: false,
                                createUpdateDisabled: false,
                              });
                            })
                            .catch(() => {
                              this.setState({
                                dataBeingSaved: false,
                                createUpdateDisabled: false,
                              });
                            });
                        }
                      }}
                    >
                      {this.state.complaintData.ComplaintID
                        ? "Update"
                        : "Create"}
                    </Button>
                  </Spin>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 12 }}
                  sm={{ span: 4 }}
                  md={{ span: 5 }}
                  lg={{ span: 5 }}
                >
                  <Spin
                    tip="Generating data..."
                    spinning={this.state.printDataLoading}
                  >
                    <Button
                      icon={<PrinterOutlined style={{ color: "#1890ff" }} />}
                      style={{ width: "100%", borderRadius: 20 }}
                      disabled={
                        this.state.printIsDisabled ||
                        !this.state.complaintData.ComplaintID
                      }
                      onClick={async () => {
                        if (this.state.complaintData.ComplaintID)
                          this.printReport(
                            "?request=true&ComplaintID=" +
                              this.state.complaintData.ComplaintID
                          );
                      }}
                    >
                      Print
                    </Button>
                  </Spin>
                </Col>
                {/* <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 0 }}
                  md={{ span: 0 }}
                  lg={{ span: 0 }}
                  style={{ marginTop: 10 }}
                ></Col> */}
                <Col
                  span={6}
                  xs={{ span: 12 }}
                  sm={{ span: 4 }}
                  md={{ span: 3 }}
                  lg={{ span: 3 }}
                >
                  <Button
                    icon={<CloseOutlined style={{ color: "purple" }} />}
                    style={{ width: "100%", borderRadius: 20 }}
                    onClick={() => {
                      this.getInitialState().then((state) =>
                        this.setState(state)
                      );
                    }}
                  >
                    Reset
                  </Button>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 12 }}
                  sm={{ span: 4 }}
                  md={{ span: 3 }}
                  lg={{ span: 3 }}
                >
                  <Popconfirm
                    title="Are you sure to delete ?"
                    onConfirm={(e) => {
                      if (
                        decodedToken.value.User_ID !== 1 &&
                        (!stateStore.permissions[65] ||
                          stateStore.permissions[65].UDelete === "N")
                      )
                        return message.warning(
                          "No permission to perform this action!"
                        );
                      if (this.state.complaintData.ComplaintID) {
                        this.setState({
                          deletionDisabled: true,
                          deletingComplaint: true,
                        });
                        axiosInstance
                          .delete(
                            complaint +
                              "/" +
                              this.state.complaintData.ComplaintID
                          )
                          .then((res) => {
                            if (res.data.success) {
                              this.getInitialState().then((state) =>
                                this.setState(state)
                              );
                              notification.success({
                                message: "Success",
                                description: "Deleted!",
                              });
                            } else
                              notification.error({
                                message: "Fail",
                                description:
                                  res.data.message || "Something went wrong!",
                              });
                            this.setState({
                              deletionDisabled: false,
                              deletingComplaint: false,
                            });
                          })
                          .catch(() => {
                            this.setState({
                              deletionDisabled: false,
                              deletingComplaint: false,
                            });
                          });
                      }
                    }}
                    // onCancel={cancel}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Spin spinning={this.state.deletingComplaint} tip="">
                      <Button
                        icon={<DeleteOutlined style={{ color: "red" }} />}
                        style={{
                          width: "100%",
                          borderRadius: 20,
                        }}
                        disabled={
                          !this.state.complaintData.ComplaintID ||
                          this.state.deletionDisabled ||
                          this.state.complaintData.closed
                        }
                      >
                        Delete
                      </Button>
                    </Spin>
                  </Popconfirm>
                </Col>
                {/* <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 0 }}
                  md={{ span: 0 }}
                  lg={{ span: 0 }}
                  style={{ marginTop: 10 }}
                ></Col> */}
                {/* <Col
                  span={6}
                  xs={{ span: 6 }}
                  sm={{ span: 0 }}
                  md={{ span: 0 }}
                  lg={{ span: 0 }}
                ></Col> */}
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 4 }}
                  md={{ span: 3 }}
                  lg={{ span: 3 }}
                >
                  <Button
                    icon={<SearchOutlined />}
                    style={{
                      width: "100%",
                      borderRadius: 20,
                    }}
                    disabled={
                      decodedToken.value.activeKey === "employee" &&
                      decodedToken.value.User_ID !== 1 &&
                      stateStore.permissions[65] &&
                      stateStore.permissions[65].UView === "N"
                    }
                    onClick={() =>
                      stateStore.navAble
                        ? stateStore.navAble({
                            defaultSelectedKeys: ["jobSearch"],
                            routableProps: { caller: "jobRegistration" },
                          })
                        : null
                    }
                  >
                    Find
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
          <Modal
            visible={this.state.signatureModalIsVisible}
            title="Tenant's Signature"
            bodyStyle={{
              padding: 10,
              height: window.innerHeight / 2,
            }}
            centered
            style={{
              maxHeight: window.innerHeight - 150,
            }}
            footer={
              <>
                <Button
                  onClick={() => {
                    if (this.signatureRef) this.signatureRef.clear();
                  }}
                >
                  Clear
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    let state = this.state;
                    state.signatureModalIsVisible = false;
                    if (this.signatureRef) {
                      if (this.signatureRef.isEmpty())
                        return message.warning("No signature provided !");
                      state.complaintData.OpenClosed = "Closed";
                      this.state.subStatusData.list.map((ssd, index) => {
                        if (ssd.UserName === "Completed") {
                          state.subStatusData.selectedIndex = index;
                          state.subStatusData.selectedValue = ssd.UserName;
                          state.complaintData.ComplaintStatusID =
                            ssd.ComplaintStatusID;
                        }
                        return ssd;
                      });
                      let dataURLtoFile = (dataurl, filename) => {
                        let arr = dataurl.split(",");
                        let mime = arr[0].match(/:(.*?);/)[1];
                        let bstr = atob(arr[arr.length - 1]);
                        let n = bstr.length;
                        let u8arr = new Uint8Array(n);
                        while (n--) {
                          u8arr[n] = bstr.charCodeAt(n);
                        }
                        return new File([u8arr], filename, { type: mime });
                      };
                      let theFile = dataURLtoFile(
                        this.signatureRef
                          .getTrimmedCanvas()
                          .toDataURL("image/png"),
                        "Signature.png"
                      );
                      state.attachmentList = [...state.attachmentList, theFile];
                    }
                    this.setState(state);
                  }}
                >
                  Ok
                </Button>
              </>
            }
            onCancel={() => {
              let state = this.state;
              state.signatureModalIsVisible = false;
              this.setState(state);
            }}
          >
            <div className="container">
              <div className="sigContainer">
                <SignaturePad
                  canvasProps={{
                    // width: "200",
                    // height: "200",
                    className: "sigPad",
                  }}
                  // canvasProps={{ className: "sigPad" }}
                  ref={(ref) => {
                    this.signatureRef = ref;
                  }}
                />
              </div>
            </div>
          </Modal>
          <iframe
            hidden={this.state.reportViewerIsHidden}
            ref={(e) => (this.reportViewerRef = e ? e : null)}
            title="Report"
            src={this.state.reportURL}
            type="application/pdf"
            name="Report View"
            id="Report View"
            width="100%"
            style={{ border: 0 }}
            height={window.innerHeight - 110}
          ></iframe>
        </Spin>
        <BackTop
          style={{
            height: 40,
            width: 40,
            lineHeight: "40px",
            borderRadius: 20,
            borderWidth: 5,
            backgroundColor: "#001529",
            color: "white",
            textAlign: "center",
            fontSize: 14,
          }}
          target={() => document.getElementById("theBody")}
        >
          <div>
            <ArrowUpOutlined />
          </div>
        </BackTop>
      </div>
    );
  }
}

export default withRouter(JobRegistration);
